import { Tag } from 'antd';
import OverlayTrigger from 'components/shared/tooltip/Tooltip';
import dayjs from 'dayjs';
import SelectableTooltip from 'components/shared/selectable-tooltip/SelectableTooltip';
import moment from 'moment';
import { Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { arrayToObject, nestedArrayToObject } from 'utils/utils';
import styleVars from '../assets/styles/helpers/_vars.scss';
const documentTooltip = (description) => {
  return (
    <Tooltip
      className='gne-tooltip'
      bsclass='gne-tooltip tooltip__black'>
      <span className='text text__x-small'>{description}</span>
    </Tooltip>
  );
};

export const renderTitleTooltip = (title, description, placement = 'auto') => {
  return (
    <span>
      {title}
      <OverlayTrigger
        placement={placement}
        overlay={<Tooltip className='gne-tooltip'>{description}</Tooltip>}>
        <i className='icon icon__info__gray ms-2'></i>
      </OverlayTrigger>
    </span>
  );
};

export const customerTypeTooltip = () => {
  return (
    <Tooltip className='gne-tooltip'>
      Account: In C360, an account represents physical entities such as
      Corporate Parents (CPs) or headquarters that serve as parent organizations
      that own multiple hospitals, clinics, or group practices. Additionally,
      accounts in C360 include Oncology Supergroups like AON and Athena,
      expanding beyond just CPs.
      <br />
      <br />
      Site: Sites, while also physical entities, are typically points of care
      where patients receive treatment. These locations, such as hospitals and
      clinics, are either fully owned by an account (CPs) or exist as
      independent entities (e.g. brothers pharmacy, llc). Unknown Zip accounts
      can also be located under Site category.
      <br />
      <br />
      Payer-Parent: Corporate entities that own payer(s), and potentially other
      related entities
      <br />
      <br />
      Payer: An insurance provider that covers the cost of healthcare
      products/services in exchange for a premium
      <br />
      <br />
      GPO: Coming Soon!
      <br />
      <br />
    </Tooltip>
  );
};

// Helper function for secure client-side sorting
export const createSecureSorter = (dataPath, sortType = 'string') => {
  return (a, b) => {
    // Get values from the data path (e.g., 'ecosystemName' or 'salesNumber.estimatedPayer')
    let valA = dataPath.split('.').reduce((obj, key) => obj?.[key], a);
    let valB = dataPath.split('.').reduce((obj, key) => obj?.[key], b);

    // Handle null/undefined values
    if ((valA == null || valA === '') && (valB == null || valB === ''))
      return 0;
    if (valA == null || valA === '') return -1;
    if (valB == null || valB === '') return 1;

    if (sortType === 'number') {
      return parseFloat(valA) - parseFloat(valB);
    } else {
      return String(valA)
        .toLowerCase()
        .localeCompare(String(valB).toLowerCase());
    }
  };
};

export const HOME_MARKETING_FILTERS = 'HomeMarketingFilters';
export const INSIGHT_MARKETING_FILTERS = 'InsightMarketingFilters';
export const INSIGHTS_DEFAULT_TEXT =
  'Navigate to a customer view and select “Add to My Insights” to populate a list of recent insight boards';
export const FAVORITE_DASHBOARD_DEFAULT_TEXT =
  'Select a dashboard in the navigation to populate a list of recent dashboards.';
export const EXPRESSION_PLACEHOLDER_TEXT = 'vReplaceString';
export const FILTER_PLACE_HOLDER = 'vAllFilters';
export const ACCOUNT_PLACE_HOLDER = 'vAllPriorityAccounts';
export const PING_FEDERATE_URL = `https://${process.env.REACT_APP_WEB_ENV}.roche.com/as/authorization.oauth2?response_type=code&client_id=analyticsHub&scope=openid+profile&redirect_uri=${process.env.REACT_APP_WEB_HOST}/authenticate`;

export const CUSTOMER_VIEW_TEXT = 'Customer View - ';
export const CUSTOMER_VIEW_SHARE_IB = 'ShareInsightBoard';
export const ADVANCE_FILTER = 'AdvanceFilter';
export const EMPTY_ARRAY = [];
export const EMPTY_STRING = '';
export const EMPTY_OBJECT = {};
export const NUMBER_ZERO = 0;
export const NUMBER_ONE = 1;
export const NUMBER_TWO = 2;
export const NUMBER_THREE = 3;
export const NUMBER_THIRTYFIVE = 35;
export const BOOLEAN_TRUE = true;
export const BOOLEAN_FALSE = false;
export const DASHBOARD_IB_LENGTH = 5;
export const REPLACE_STRING = 'vReplaceString';
export const DATE_FORMAT = 'MMM D, yyyy';
export const DATE_FORMAT_COMMA = 'll';
export const DEFAULT_DATE_FORMAT = 'dddd MMM DD YYYY hh:mm:ss';
export const DEFAULT_DATE_FORMAT_2 = 'dddd MMM D YYYY hh:mm:ss';
export const FILTER_DATE_FORMAT = 'MM/DD/YYYY';
export const FILTER_DATE_FORMAT_2 = 'M/D/YYYY';
export const VIEW_FILTER_DATE_FORMAT = 'MMM DD, YYYY';
export const YEAR_QUARTER_DATE_FORMAT = 'YYYY[Q]Q';
export const QUARTER_YEAR_DATE_FORMAT = '[Q]Q YY';
export const MONTH_YEAR_DATE_FORMAT = 'MMM YY';
export const MONTH_YEAR_FORMAT = 'MM/YY';
export const MONTH_FULL_YEAR_FORMAT = 'MM/YYYY';
export const MAX_DATE_RANGE = 2; // years
export const MIN_DATE_RANGE = 5; // months
export const DEFAULT_MAX_DATE_RANGE = 15; // days
export const DEFAULT_MIN_DATE_RANGE = 1; // days
export const NULL_STRING = '--';
export const NULL_VALUE = null;
export const NOT_AVAILABLE = 'Not Available';
export const NOT_APPLICABLE = 'Not Applicable';
export const CHART_UPDATE_MESSAGE = 'Chart updated successfully';
export const KPI_UPDATE_MESSAGE =
  'Please update the title of this KPI (key performance indicator) tile if needed';
export const CHART_ADD_MESSAGE = 'Chart added successfully';
export const CHART_LIMIT_ERROR =
  'You cannot create more than 20 tiles in a view. Consider adding a new view using the Add New View button.';
export const ADD_TO_MY_VIEW_MESSAGE =
  'Tile has been added to the desired view(s) successfully';
export const DUPLICATE_INSIGHT_VIEW_MESSAGE =
  ' The tile has been duplicated and added to the Insight Board.';
export const DUPLICATE_TO_MY_VIEW_MESSAGE =
  'The tile has been duplicated and added to this View.';
export const ACTION_COPY = 'copy';
export const ACTION_ADD_TO_VIEW = 'addToView';
export const COPY_TITLE_PREFIX = 'Copy of ';
export const SITE_PERFORMANCE_FILTER_NAME = 'Site';
export const SITE_UTILIZATION_FILTER_NAME = 'SiteUtilization';
export const COPAY_ANALYTICS_FILTER_NAME = 'CopayAnalytics';
export const AFFILATION_FILTER_NAME = 'Affilation';
export const PRODUCT_MIX_FILTER_NAME = 'ProductMix';
export const CONFIGURE_INSIGHTS_FILTER_NAME = 'configureInsights';
export const TABLE_NAME_ECOSYSTEM_OPPORTUNITY = 'EcosystemOpportunity';
export const DEFAULT_MESSAGE =
  'Please select an Account to view the hierarchy. An Account could be a corporate parent or a sub-account that rolls up to a corporate parent. Please select the Site radio button if you are looking for specific sites of care.';
export const DEFAULT_MESSAGE_SITE =
  'Please select Site of Care to view the hierarchy it belongs to. If you are looking for a corporate parent or a sub-account that rolls up to a corporate parent, please select the Account radio button.';

export const INSIGHTS_CHART_LIMIT_ERROR =
  'You cannot create more than 12 tiles in a view. Consider adding a new view using the Actions menu.';
export const CARD_POISTIONS_UPDATED_MESSAGE = 'Positions updated successfully.';
export const CARD_POISTIONS_ERROR_MESSAGE =
  'Positions not updated! Some error occured';
export const ADD_SITE_SUBTEXT =
  'Search for sites below to change its hierarchy.';
export const REMOVE_SITE_SUBTEXT =
  'Search for site(s) below to remove them from the hierarchy.';
export const EDIT_340B_SUBTEXT =
  'Search for site(s) below to update 340B contract information.';
export const NO_SITE_SELECTED = 'No Site Selected';
export const NO_SITE_SELECTED_SUBTEXT = 'Please use the filters to view sites';
export const ALL = 'All';
export const CUSTOMER_HELP_TEXT = 'Search Customer Name or Street Address';
export const CUSTOMER_TOOLTIP_TEXT =
  'Customer is any stakeholder Genentech interacts with, including Accounts (e.g. Corporate Parents), Sites (e.g. Clinics/Hospitals), and Payers. You can search for them by name or address, and if needed, use the Advanced Search feature to refine your results by selecting criteria such as customer type, city, state, or zip.';
export const CUSTOMER_TOOLTIP_TEXT_PART2 =
  'Unchecking the priority checkbox enables analysis focused on your geography, while checking it provides a comprehensive view of your priority customers across all geographies.';
export const DIMENSION_TOOLTIP_TEXT =
  'A dimension defines the lens through which you view and break down your metrics, such as by product, by ecosystem, or other categories.';
export const KPI_TOOLTIP_TEXT =
  'KPIs are the metrics you aim to track for your specific geography or customer. They are sourced from existing approved dashboards such as EA BI, CARE, etc.';
export const FILTER_MESSAGE =
  'This account has a large dataset. Consider filtering if you plan to export it to a PDF file';
export const COPY_VIEW_SUCCESS_MESSAGE =
  'Tile has been copied to the desired view(s) successfully';
export const MY_VIEW_ADD_TILE_LIMIT =
  'The view you are trying to copy this tile to has 20 tiles (maximum limit) in it and cannot accept more tiles.';
export const INSIGHT_TILE_LIMIT_EXCEED_MSG =
  'The view you are trying to copy this tile to has 12 tiles (maximum limit) in it and cannot accept more tiles.';
export const ADD_NEW_VIEW_SUCCESS_MESSAGE =
  'A new view has been successfully created and saved in your My View list.';
export const ADD_NEW_INSIGHT_VIEW_SUCCESS_MESSAGE =
  'A new view has been created.';
export const ADD_FIRST_INSIGHT_VIEW_SUCCESS_MESSAGE =
  'A new view has been created. You can now find this saved insight board in the Customer View homepage.';
export const MESSAGE_PROVIDE_TITLE = 'Please provide a title of the view.';
export const ERR_MAX_CHAR_LIMIT_EXCEEDS = 'Title cannot exceed 128 characters.';
export const SPECIAL_CHAR_ERROR_MESSAGE =
  'Only special characters such as ( ) _ # & - + . : are allowed.';
export const RESTRICT_SPECIAL_CHAR =
  /[`…©“”‘’¿¡¤§†‡‰‽®™€£¥₹¢₩₽₦~!@$%^*=[\]{};'"\\|,<>/?]+/;
export const PATHWAY_URL =
  'https://drive.google.com/drive/folders/191ZWMnQ4SUvJg7d6scNpXHxOE0th_HLq?pli=1';
export const PRP_ENOTICE = 'PRP eNotices';
export const areas = {
  bannerCustomerInfo: 'banner-customer-info',
  bannerInteraction: 'banner-interaction',
  bannerUses: 'banner-uses',
  bannerNPS: 'banner-nps',
  bannerSat: 'banner-sat',
  bannerPartner: 'banner-partner',
  bannerSegment: 'banner-segment',
  bannerBoB: 'banner-bob',
  home: 'home-area',
  customerViewList: 'view-list',
  customerView: 'customer-view',
  trends: 'trends-view',
  customerViewLoader: 'customer-loader',
  timeline: 'timeline-view',
  defaultView: 'default-view',
  priorityView: 'priority-view',
  userView: 'user-views',
  deleteCardsThenView: 'delete-cards-then-view',
};
export const CONFIGURE_VIEW = {
  insights: 'Insights',
  myView: 'my view',
  myDefault: 'my default',
  viewList: 'viewList',
  customerView: 'customerView',
  configurePriority: 'configurePriority',
  trends: 'trends',
  teamSetup: 'teamSetup',
  orgHierarchy: 'orgHierarchy',
  copyInsight: 'copyInsight',
};

export const QLIK_DATATYPE = {
  single: 'single',
  chartBar: 'bar',
  chartPie: 'pie',
  payerPie: 'payerPie',
  contractPie: 'contractPie',
  multiObject: 'object',
};

export const VIEW = {
  trends: 'trends',
  myPriority: 'myPriority',
  teamPOC: 'teamPOC',
  edit: 'edit',
  add: 'add',
  customer: 'customer',
};

export const VIEW_TEXT = {
  updateInsights: 'Update Insights',
  addInsights: 'Add to Insights',
  addMyView: 'Add To My View',
  updateMyView: 'Update My View',
};

export const IMPACTED_GD_VIDEO_URL =
  'https://drive.google.com/file/d/1vUNzCqtlrIixVMty8OzwYUvKGW0b2UfC/view?usp=sharing';
export const GUIDELINE_TEXT =
  'Start by selecting the KPI you want to evaluate, then choose the Dimension by which to break it down, select the Customer for whom you are evaluating, and finally apply filters to narrow your data in visuals.';

export const GUIDELINE_TEXT_CV =
  'Start by selecting the KPI you want to evaluate, then choose the Dimension by which to break it down, and finally select the Customer for whom you are evaluating.';

export const ADVANCED_SEARCH_NOTE =
  'Note: Advanced selection narrows the Customer universe for your selection without impacting tiles; use left-side filters to narrow down data.';
export const ORG_ACTIONS = {
  add: 'add',
  remove: 'remove',
  move: 'move',
  create: 'create',
  assign: 'assign',
  comments: 'comments',
  filter: 'filter',
  info: 'info',
  edit340: 'edit',
  contractsegment: 'contractsegment',
};

export const FLAG = {
  site: [2, 3],
  account: 1,
  filter: 'filter',
};

export const ColumnVisiblity = {
  Mandatory: 'Mandatory',
  Default: 'Default',
  Optional: 'Optional',
};

export const optionsInitialState = {
  ecosystem: [],
  siteName: [],
  city: [],
  state: [],
  zip: [],
  class: [],
  label: [],
  contract_segment: [],
  hin: [],
  dea: [],
  program_type: [],
  stakeHolderCounts: '',
  grossSales: '',
  squad: [],
  product: [],
};

export const optionsInitialStateOffset = {
  ecosystem: 0,
  siteName: 0,
  city: 0,
  state: 0,
  zip: 0,
  class: 0,
  label: 0,
  contract_segment: 0,
  hin: 0,
  dea: 0,
  program_type: 0,
  squad: 0,
  product: 0,
};

export const optionsInitialStateDefault = {
  ecosystem: false,
  siteName: false,
  city: false,
  state: false,
  zip: false,
  class: false,
  label: false,
  contract_segment: false,
  hin: false,
  dea: false,
  program_type: false,
  squad: false,
  product: false,
};
export const ACTION_TYPE = {
  node: 'actions-node',
  filter: 'actions',
  addTo: 'addTo',
  moveSite: 'moveSite',
  addSite: 'addSites',
  reason: 'reason',
  info: 'info',
  orgFilter: 'orgFilter',
  add: 'add',
  move: 'move',
  remove: 'remove',
};

export const SITE_PERFORMANCE_EXPRESSION = {
  expression: `Date(AddMonths(Date#(max({1<[Latest Month Flag]={1}>} Date((Date#([Month Year],'YYYYMMDD')),'MM''YYYY')),'MM''YYYY'),-(11)),'MMM''YY')&' - ' & Date(Date#(max({1<[Latest Month Flag]={1}>} Date((Date#([Month Year],'YYYYMMDD')),'MM''YYYY')),'MM''YYYY'),'MMM''YY')`,
  appId: process.env.REACT_APP_EABI_APP_ID,
};

export const CRM_EXPRESSIONS = {
  quarters: `Only({<curr_qtr={"C"}, vReplaceString>}[Quarter Year])`,
  month: `Date(min({<curr_qtr={"C"}>}Date), 'MMM''YY') & ' - ' & Date(max({<curr_qtr={"C"}>}Date), 'MMM''YY')`,
  nps: {
    score: 'Max({<curr_qtr={"C"}, vReplaceString>}relationship_nps)',
    percent: `
    if(IsNull( max({<curr_qtr={'C'}, vReplaceString>}relationship_nps)),'-',(max({<curr_qtr={'C'}, vReplaceString>}relationship_nps)-max({<curr_qtr={'P'}, vReplaceString>}relationship_nps)))
    `,
  },
  nps_site: {
    score: 'Max({<curr_qtr={"C"}, vReplaceString>}site_relationship_nps)',
    percent: `
  if(IsNull( max({<curr_qtr={'C'}, vReplaceString>}site_relationship_nps)),'-',(max({<curr_qtr={'C'}, vReplaceString>}site_relationship_nps)-max({<curr_qtr={'P'}, vReplaceString>}site_relationship_nps)))
  `,
  },
  sat: {
    score:
      'Max({<curr_qtr={"C"}, vReplaceString>}post_interaction_overall_sat)',
    percent: `
    if(IsNull( max({<curr_qtr={'C'}, vReplaceString>}post_interaction_overall_sat)),'-',(max({<curr_qtr={'C'}, vReplaceString>}post_interaction_overall_sat)-max({<curr_qtr={'P'}, vReplaceString>}post_interaction_overall_sat)))
    `,
  },
  sat_site: {
    score:
      'Max({<curr_qtr={"C"}, vReplaceString>}site_post_interaction_overall_sat)',
    percent: `
    if(IsNull( max({<curr_qtr={'C'}, vReplaceString>}site_post_interaction_overall_sat)),'-',(max({<curr_qtr={'C'}, vReplaceString>}site_post_interaction_overall_sat)-max({<curr_qtr={'P'}, vReplaceString>}site_post_interaction_overall_sat)))
    `,
  },
  partner: {
    score:
      'Max({<curr_qtr={"C"}, vReplaceString>}relationship_trusted_partner)',
    percent: `
    if(IsNull( max({<curr_qtr={'C'}, vReplaceString>}relationship_trusted_partner)),'-',(max({<curr_qtr={'C'}, vReplaceString>}relationship_trusted_partner)-max({<curr_qtr={'P'}, vReplaceString>}relationship_trusted_partner)))
    `,
  },
  partner_site: {
    score:
      'Max({<curr_qtr={"C"}, vReplaceString>}site_relationship_trusted_partner)',
    percent: `
    if(IsNull( max({<curr_qtr={'C'}, vReplaceString>}site_relationship_trusted_partner)),'-',(max({<curr_qtr={'C'}, vReplaceString>}site_relationship_trusted_partner)-max({<curr_qtr={'P'}, vReplaceString>}site_relationship_trusted_partner)))
    `,
  },
  lineChart: {
    nps: {
      expression: 'Max({< vReplaceString>}relationship_nps)',
    },
    sat: {
      expression: 'Max({<vReplaceString>}post_interaction_overall_sat)',
    },
    partner: {
      expression: 'Max({<vReplaceString>}relationship_trusted_partner)',
    },
    dimension: 'Quarter Year',
  },
  lineChart_site: {
    nps: {
      expression: 'Max({< vReplaceString>}site_relationship_nps)',
    },
    sat: {
      expression: 'Max({<vReplaceString>}site_post_interaction_overall_sat)',
    },
    partner: {
      expression: 'Max({<vReplaceString>}site_relationship_trusted_partner)',
    },
    dimension: 'Quarter Year',
  },
  surveys: {
    nps: 'Count({< curr_qtr={"C"}, Engagement={"VOC Survey Response"},tableflag={"medallia_field_relationship_daily"}, vReplaceString>} distinct ID)',
    sat: 'Count({< curr_qtr={"C"}, Engagement={"VOC Survey Response"},tableflag={"medallia_field_post_interaction_commercial_medical_daily"}, vReplaceString>} distinct ID)',
    partner:
      'Count({< curr_qtr={"C"}, Engagement={"VOC Survey Response"},tableflag={"medallia_field_relationship_daily"}, vReplaceString>} distinct ID)',
  },
  payment_method: `if(len(MinString({<vReplaceString>}Payment_Method))>1,MinString({<vReplaceString>}Payment_Method),'Not Available')`,
  voc_alert_flag: 'MaxString({<vReplaceString>}alert)',
  appId: process.env.REACT_APP_CRM_APP_ID,
};
export const BEAM_EXPRESSIONS = {
  contractSegment: {
    expression: `Sum({<curr_qtr={"C"}, segment_flag={1}, vReplaceString>}sales_amt)`,
    dimension: 'rpt_segment_name',
  },
  quarter: 'Only({<curr_qtr={"C"}, vReplaceString>}[Quarter Year])',
  affilliated: 'maxstring({<vReplaceString>}[GPO NAME])',
  id340B: 'MaxString({<vReplaceString>}[340B_ID])',
  appId: process.env.REACT_APP_BEAM_APP_ID,
};

export const BEAM_EXPRESSIONS_SITE = {
  contractSegment: {
    expression: `Sum({<curr_qtr={"C"}, segment_flag={1}, vReplaceString>}sales_amt)`,
    dimension: 'rpt_segment_name',
  },
  contractSegmentRebate: {
    expression: `Sum({<curr_qtr={"C"}, segment_flag={1}, vReplaceString>}rebate)`,
    dimension: 'rpt_segment_name',
  },
  contractSegmentDiscount: {
    expression: `Sum({<curr_qtr={"C"}, segment_flag={1}, vReplaceString>}discount)`,
    dimension: 'rpt_segment_name',
  },
  contractSegmentMembership: {
    expression: `MaxString({<vReplaceString>}Membership)`,
    dimension: 'rpt_segment_name',
  },
  quarter: 'Only({<curr_qtr={"C"}, vReplaceString>}[Quarter Year])',
  affilliated: 'maxstring({<vReplaceString>}[GPO NAME])',
  oncSuperGroup:
    "Only({<Customer_Type={'Site'}, vReplaceString>} ONC_SuperGroup)",
  oncGPO: "Only({<Customer_Type={'Site'}, vReplaceString>} ONC_GPO)",
  appId: process.env.REACT_APP_BEAM_APP_ID,
};

export const USES = {
  expression: `Only({<vReplaceString>}[Parent Organization])`,
  dimension: 'Account',
  appId: process.env.REACT_APP_PATHWAYS_APP_ID,
};

export const PAYERMIX_EXPRESSION = {
  expression: ``,
  dimension: ``,
};

export const ENGAGEMENT_TYPE = {
  internal: 'Internal',
  external: 'External',
};
export const ENGAGEMENTS = {
  phone: 'Phone',
  email: 'Email',
  inPerson: 'In Person (F2F)',
  video: 'Video',
  houseEmail: 'House Email',
  surveySent: 'VOC Survey Sent',
  surveyResponse: 'VOC Survey Response',
  medicalInquiry: 'Medical Inquiry',
  accessSolutions: 'Access Solutions - Enrollment',
  message: 'Message',
  vae: 'VAE',
  pact: 'PACT - Enrollment',
  prpeNotices: PRP_ENOTICE,
};
export const HOUSE_EMAIL_STATUS = {
  delivered: 'DELIVERED',
  clicked: 'DELIVERED CLICKED',
  opened: 'DELIVERED OPENED',
};

export const AFFILIATION_INFO_EXPRESSIONS = {
  expression: 'Count({<vReplaceString>} distinct hcp_outlet_mdm_id)',
  AFFILIATION_QLIK_APP_ID: process.env.AFFILIATION_APP_ID,
  ENGAGEMENT_COUNT: `Count({<Date ={">=$(=Date(Today()-90, 'MM/DD/YYYY'))"},  Site_ID={"vReplaceString"}>} distinct ID)`,
  GROSS_SALES: `sum({<R12={"C"},brand_flag={1}, Site_ID={"vReplaceString"}>}[GNE 867 Dollar Sales])`,
};

export const ENGAGEMENT_DIMENSION_MAP = {
  source: 'Source',
  engagement: 'Engagement',
  engagementType: 'Engagement Type',
  engagementDate: 'Date',
  userName: 'GNE User Name',
  userRole: 'GENE User Role',
  stakeholderName: 'Person Stakeholder Name',
  stakeholderType: 'Person Stakeholder Type',
  topic: 'Topic',
  product: 'Product_CV',
};

export const ENGAGEMENT_EXPRESSIONS = {
  details: {
    expression: 'Count({<vReplaceString>} distinct ID)',
    dimensions: [
      'Source',
      'Engagement',
      'Engagement Type',
      'Date',
      'ID',
      'GNE User Name',
      'GENE User Role',
      'Person Stakeholder Name',
      'Person Stakeholder Type',
      'Topic',
      'Indication',
      'Squad',
      'Product_CV',
      'Child Call ID',
      'Person_Stakeholder_Link',
      'veevaUrl',
      'Engagement Note',
      'Discussion Note',
      'Engagement_CLM_Presentation',
      'BEM Email Address',
      'Account Payable Email',
      'Email Subject Line',
      'Email Link',
    ],
  },
  metrics: {
    expression: 'Count({<vReplaceString>} distinct ID)',
    dimension: ['Engagement', 'Engagement Type', 'Source'],
  },
  appId: process.env.REACT_APP_CRM_APP_ID,
};

export const FIELDNAMELIST = [
  'StakeholderName',
  'StakeholderType',
  'Engagement',
  'Squad',
  'Brand',
  'Indication',
];
export const SITE_PERF_FIELDNAME_LIST = ['Site', 'Product'];
export const FILTER_FIELDS = {
  SITE_SQUAD: 'SiteSquad',
  PRODUCT: 'Product',
};
export const SITE_PERF_APP_ID = process.env.REACT_APP_EABI_APP_ID;
export const SITE_UTILIZATION_TABLE = 'siteutilization';
export const SITE_UTILIZATION_APP_ID =
  process.env.REACT_APP_SITE_UTILIZATION_APP_ID;
export const PAYER_MIX_QLIK_ID = process.env.REACT_APP_PAYER_ID;
export const COPAY_ANALYTICS_APP_ID =
  process.env.REACT_APP_COPAY_ANALYTICS_APP_ID;
export const PRODUCT_MIX_QLIK_ID = process.env.REACT_APP_PRODUCT_MIX_ID;
export const CRM_APP_ID = process.env.REACT_APP_CRM_APP_ID;
export const ACCOUNT_PAYER_APP_ID = process.env.REACT_APP_ACCOUNT_PAYER_APP_ID;
const generalDimensions = [
  'Source',
  'Engagement',
  'Date',
  'GNE User Name',
  'GENE User Role',
  'Person Stakeholder Name',
  'Person Stakeholder Type',
  'Topic',
  'ID',
  'Status',
  'Site Name',
  'Site Address',
  'Submitted Date',
  'Product',
  'Indication',
  'Engagement Note',
  'Discussion Note',
  'Engagement Type',
  'Engagement_CLM_Presentation',
];

const surveyDimensions = [
  'Source',
  'Engagement',
  'Date',
  'GNE User Name',
  'GENE User Role',
  'Person Stakeholder Name',
  'Person Stakeholder Type',
  'Topic',
  'ID',
  'Status',
  'Site Name',
  'Site Address',
  'Submitted Date',
  'Product',
  'Indication',
  'Engagement Note',
  'Engagement Type',
  'Engagement_CLM_Presentation',
];
const productDimensions = [
  'Source',
  'Engagement',
  'Date',
  'GNE User Name',
  'GENE User Role',
  'Person Stakeholder Name',
  'Person Stakeholder Type',
  'Topic',
  'ID',
  'Status',
  'Product',
  'Engagement Type',
  'Engagement_CLM_Presentation',
];

const contractDimensions = [
  'Source',
  'Engagement',
  'Date',
  'GNE User Name',
  'GENE User Role',
  'Person Stakeholder Name',
  'Person Stakeholder Type',
  'Topic',
  'ID',
  'Status',
  'Site Name',
  'Site Address',
  'Submitted Date',
  'Product',
  'Indication',
  'Engagement Note',
  'Discussion Note',
  'BEM Email Address',
  'Account Payable Email',
  'Email Subject Line',
  'Email Link',
];
export const ENGAGEMENT_DRILL_DOWN = {
  expression: 'Count({< vReplaceString>} distinct ID)',
  mappings: {
    VAE: {
      'Veeva CRM': {
        dimensions: productDimensions,
      },
    },
    Email: {
      'Veeva CRM': {
        dimensions: generalDimensions,
      },
    },
    Phone: {
      'Veeva CRM': {
        dimensions: generalDimensions,
      },
    },
    'In Person (F2F)': {
      'Veeva CRM': {
        dimensions: generalDimensions,
      },
    },
    Message: {
      'Veeva CRM': {
        dimensions: generalDimensions,
      },
    },
    Video: {
      'Veeva CRM': {
        dimensions: generalDimensions,
      },
    },
    'VOC Survey Response': {
      'Veeva CRM': {
        dimensions: surveyDimensions,
      },
    },
    'VOC Survey Sent': {
      'Veeva CRM': {
        dimensions: surveyDimensions,
      },
    },
    'House Email': {
      Marketing: {
        dimensions: productDimensions,
      },
    },
    'Medical Inquiry': {
      'Synapse- MedComm': {
        dimensions: [
          'Source',
          'Engagement',
          'Date',
          'GNE User Name',
          'GENE User Role',
          'Person Stakeholder Name',
          'Person Stakeholder Type',
          'Topic',
          'ID',
          'Status',
          'Inquiry Type',
          'Product',
          'Indication',
          'Engagement Note',
          'Engagement_CLM_Presentation',
        ],
      },
    },
    'PACT - Enrollment': {
      'Access Solution': {
        dimensions: [
          'Source',
          'Engagement',
          'Date',
          'GNE User Name',
          'GENE User Role',
          'Person Stakeholder Name',
          'Person Stakeholder Type',
          'Topic',
          'ID',
          'Status',
          'Site Name',
          'Site Address',
          'Product',
          'Engagement Note',
          'Engagement_CLM_Presentation',
        ],
      },
    },
    'PRP eNotices': {
      PRP: {
        dimensions: contractDimensions,
      },
    },
  },
  appId: process.env.REACT_APP_CRM_APP_ID,
};

export const ENGAGEMENT_COLUMNS = [
  {
    id: 2,
    dataIndex: 'engagement',
    key: 'engagement',
    title: 'Engagement',
    isMandatory: 'Y',
    width: 145,
    sorter: (a, b) => a.engagement.localeCompare(b.engagement),
  },
  {
    id: 3,
    dataIndex: 'engagementType',
    key: 'engagementType',
    title: 'Engagement Type',
    isMandatory: 'N',
    width: 155,
    sorter: (a, b) => a?.engagementType?.localeCompare(b?.engagementType),
  },
  {
    id: 4,
    dataIndex: 'engagementDate',
    key: 'engagementDate',
    title: 'Date',
    isMandatory: 'Y',
    width: 120,
    render: (_, record) => (
      <>
        {moment(record?.engagementDate, [
          FILTER_DATE_FORMAT,
          FILTER_DATE_FORMAT_2,
        ]).format(DATE_FORMAT_COMMA)}
      </>
    ),
    defaultSortOrder: 'descend',
    sorter: (a, b) =>
      moment(a.engagementDate, FILTER_DATE_FORMAT).unix() -
      moment(b.engagementDate, FILTER_DATE_FORMAT).unix(),
  },
  {
    id: 5,
    dataIndex: 'engagementId',
    key: 'engagementId',
    title: 'Engagement ID',
    isMandatory: 'N',
    width: 150,
    sorter: (a, b) => a?.engagementId - b?.engagementId,
  },
  {
    id: 6,
    dataIndex: 'userName',
    key: 'userName',
    title: 'User Name',
    isMandatory: 'Y',
    width: 160,
    sorter: (a, b) => a.userName.localeCompare(b.userName),
  },
  {
    id: 7,
    dataIndex: 'userRole',
    key: 'userRole',
    title: 'User Role',
    isMandatory: 'Y',
    width: 100,
    sorter: (a, b) => {
      const roleA = a?.userRole?.toLowerCase();
      const roleB = b?.userRole?.toLowerCase();

      if (roleA && roleB) {
        return roleA.localeCompare(roleB);
      } else if (roleA) {
        return -1;
      } else if (roleB) {
        return 1;
      } else {
        return 0;
      }
    },
  },
  {
    id: 8,
    dataIndex: 'stakeholderName',
    key: 'stakeholderName',
    title: 'Stakeholder Name',
    isMandatory: 'Y',
    width: 280,
    sorter: (a, b) => a.stakeholderName.localeCompare(b.stakeholderName),
  },
  {
    id: 9,
    dataIndex: 'stakeholderType',
    key: 'stakeholderType',
    title: 'Stakeholder Type',
    isMandatory: 'Y',
    width: 130,
    sorter: (a, b) => a.stakeholderType.localeCompare(b.stakeholderType),
  },
  {
    id: 10,
    dataIndex: 'topic',
    key: 'topic',
    title: 'Topic',
    isMandatory: 'Y',
    width: 130,
    sorter: (a, b) => a?.topic?.localeCompare(b?.topic),
  },
  {
    id: 11,
    dataIndex: 'indication',
    key: 'indication',
    title: 'Indication',
    isMandatory: 'N',
    width: 150,
    sorter: (a, b) => a?.indication?.localeCompare(b?.topic),
  },
  {
    id: 12,
    dataIndex: 'squad',
    key: 'squad',
    title: 'Squad',
    isMandatory: 'N',
    width: 150,
    sorter: (a, b) => a?.squad?.localeCompare(b?.squad),
  },
  {
    id: 13,
    dataIndex: 'product',
    key: 'product',
    title: 'Product',
    isMandatory: 'Y',
    width: 150,
    sorter: (a, b) => a?.product?.localeCompare(b?.product),
  },
  {
    id: 1,
    dataIndex: 'source',
    key: 'source',
    title: 'Source',
    isMandatory: 'Y',
    width: 110,
    sorter: {
      sorter: (a, b) => a.source.localeCompare(b.source),
    },
  },
];

export const ENGAGEMENT_DOWNLOAD_COLUMNS = [
  {
    id: 2,
    dataIndex: 'engagement',
    key: 'engagement',
    title: 'Engagement',
    isMandatory: 'Y',
    width: 145,
    sorter: (a, b) => a.engagement.localeCompare(b.engagement),
  },
  {
    id: 3,
    dataIndex: 'engagementType',
    key: 'engagementType',
    title: 'Engagement Type',
    isMandatory: 'N',
    width: 155,
    sorter: (a, b) => a?.engagementType?.localeCompare(b?.engagementType),
  },
  {
    id: 4,
    dataIndex: 'engagementDate',
    key: 'engagementDate',
    title: 'Date',
    isMandatory: 'Y',
    width: 120,
    render: (_, record) => (
      <>
        {moment(record?.engagementDate, [
          FILTER_DATE_FORMAT,
          FILTER_DATE_FORMAT_2,
        ]).format(DATE_FORMAT_COMMA)}
      </>
    ),
    sorter: (a, b) =>
      moment(a.engagementDate).unix() - moment(b.engagementDate).unix(),
    defaultSortOrder: 'ascend',
  },
  {
    id: 5,
    dataIndex: 'engagementId',
    key: 'engagementId',
    title: 'Engagement ID',
    isMandatory: 'N',
    width: 150,
    sorter: (a, b) => a?.engagementId - b?.engagementId,
  },
  {
    id: 6,
    dataIndex: 'userName',
    key: 'userName',
    title: 'User Name',
    isMandatory: 'Y',
    width: 160,
    sorter: (a, b) => a.userName.localeCompare(b.userName),
  },
  {
    id: 7,
    dataIndex: 'userRole',
    key: 'userRole',
    title: 'User Role',
    isMandatory: 'Y',
    width: 100,
    sorter: (a, b) => {
      const roleA = a?.userRole?.toLowerCase();
      const roleB = b?.userRole?.toLowerCase();

      if (roleA && roleB) {
        return roleA.localeCompare(roleB);
      } else if (roleA) {
        return -1;
      } else if (roleB) {
        return 1;
      } else {
        return 0;
      }
    },
  },
  {
    id: 8,
    dataIndex: 'stakeholderName',
    key: 'stakeholderName',
    title: 'Stakeholder Name',
    isMandatory: 'Y',
    width: 280,
    sorter: (a, b) => a.stakeholderName.localeCompare(b.stakeholderName),
  },
  {
    id: 9,
    dataIndex: 'stakeholderType',
    key: 'stakeholderType',
    title: 'Stakeholder Type',
    isMandatory: 'Y',
    width: 130,
    sorter: (a, b) => a.stakeholderType.localeCompare(b.stakeholderType),
  },
  {
    id: 10,
    dataIndex: 'topic',
    key: 'topic',
    title: 'Topic',
    isMandatory: 'Y',
    width: 130,
    sorter: (a, b) => a?.topic?.localeCompare(b?.topic),
  },
  {
    id: 11,
    dataIndex: 'indication',
    key: 'indication',
    title: 'Indication',
    isMandatory: 'N',
    width: 150,
    sorter: (a, b) => a?.indication?.localeCompare(b?.topic),
  },
  {
    id: 12,
    dataIndex: 'squad',
    key: 'squad',
    title: 'Squad',
    isMandatory: 'N',
    width: 150,
    sorter: (a, b) => a?.squad?.localeCompare(b?.squad),
  },
  {
    id: 13,
    dataIndex: 'product',
    key: 'product',
    title: 'Product',
    isMandatory: 'Y',
    width: 150,
    sorter: (a, b) => a?.product?.localeCompare(b?.product),
  },
  {
    id: 1,
    dataIndex: 'source',
    key: 'source',
    title: 'Source',
    isMandatory: 'Y',
    width: 110,
    sorter: {
      sorter: (a, b) => a.source.localeCompare(b.source),
    },
  },
  {
    id: 23,
    dataIndex: 'childEngagementId',
    key: 'childEngagementId',
    title: 'Child Engagement Id',
    isMandatory: 'N',
    width: 200,
    sorter: (a, b) => a?.engagementNotes?.localeCompare(b?.childEngagementId),
  },
  {
    id: 24,
    dataIndex: 'veevaUrl',
    key: 'veevaUrl',
    title: 'Veeva Url',
    isMandatory: 'N',
    width: 200,
    sorter: (a, b) => a?.veevaUrl?.localeCompare(b?.veevaUrl),
  },

  {
    id: 26,
    dataIndex: 'EngagementNote',
    key: 'EngagementNote',
    title: 'Engagement Notes',
    isMandatory: 'N',
    width: 200,
    sorter: (a, b) => a?.engagementNotes?.localeCompare(b?.engagementNotes),
  },
  {
    id: 31,
    dataIndex: 'DiscussionNote',
    key: 'DiscussionNote',
    title: 'Discussion Notes',
    isMandatory: 'N',
    width: 200,
    sorter: (a, b) => a?.discussionNotes?.localeCompare(b?.discussionNotes),
  },

  {
    id: 30,
    dataIndex: 'Engagement_CLM_Presentation',
    key: 'Engagement_CLM_Presentation',
    title: 'CLM Presentation Name',
    isMandatory: 'N',
    width: 200,
    sorter: (a, b) =>
      a?.clmPresentationName?.localeCompare(b?.clmPresentationName),
  },
  {
    id: 41,
    dataIndex: 'BEM Email Address',
    key: 'BEM Email Address',
    title: 'BEM Email Address',
    isMandatory: 'N',
    width: 200,
    sorter: (a, b) =>
      a?.clmPresentationName?.localeCompare(b?.clmPresentationName),
  },
  {
    id: 42,
    dataIndex: 'Account Payable Email',
    key: 'Account Payable Email',
    title: 'Account Payable Email',
    isMandatory: 'N',
    width: 200,
    sorter: (a, b) =>
      a?.clmPresentationName?.localeCompare(b?.clmPresentationName),
  },
  {
    id: 43,
    dataIndex: 'Email Subject Line',
    key: 'Email Subject Line',
    title: 'Email Subject Line',
    isMandatory: 'N',
    width: 200,
    sorter: (a, b) =>
      a?.clmPresentationName?.localeCompare(b?.clmPresentationName),
  },
  {
    id: 43,
    dataIndex: 'Email Link',
    key: 'Email Link',
    title: 'Link to Attached PDF',
    isMandatory: 'N',
    width: 200,
    sorter: (a, b) =>
      a?.clmPresentationName?.localeCompare(b?.clmPresentationName),
  },
];

export const AFFILIATIONS_COLUMNS = [
  {
    id: 9,
    dataIndex: 'hcpName',
    key: 'siteId',
    title: 'Stakeholder Name',
    width: 250,
    isMandatory: 'N',
    sorter: true,
  },
  {
    id: 10,
    dataIndex: 'hcpAddress',
    key: 'siteId',
    title: 'Stakeholder Address',
    isMandatory: 'N',
    width: 250,
    sorter: true,
  },
  {
    id: 11,
    dataIndex: 'hcpCity',
    key: 'siteId',
    title: 'Stakeholder City',
    isMandatory: 'N',
    width: 150,
    sorter: true,
  },
  {
    id: 12,
    dataIndex: 'hcpState',
    key: 'siteId',
    title: 'Stakeholder State',
    width: 250,
    isMandatory: 'N',
    sorter: true,
  },
  {
    id: 13,
    dataIndex: 'hcpZip',
    key: 'siteId',
    title: 'Stakeholder Zip',
    isMandatory: 'N',
    width: 150,
    sorter: true,
  },

  {
    id: 17,
    dataIndex: 'hcpSpecialty',
    key: 'siteId',
    title: 'Primary Speciality',
    width: 250,
    isMandatory: 'N',
    sorter: true,
  },
  {
    id: 18,
    dataIndex: 'secondarySpeciality',
    key: 'siteId',
    title: 'Secondary Speciality',
    isMandatory: 'N',
    width: 250,
    sorter: true,
  },
  {
    id: 19,
    title: 'Stakeholder Type',
    dataIndex: 'stakeholderType',
    key: 'siteId',
    isMandatory: 'N',
    width: 150,
    sorter: true,
    defaultSortOrder: 'ascend',
  },
  {
    id: 2,
    dataIndex: 'siteName',
    key: 'siteName',
    title: 'Site Name',
    isMandatory: 'Y',
    width: 250,
    sorter: true,
    defaultSortOrder: 'ascend',
  },
  {
    id: 3,
    dataIndex: 'siteAddress',
    key: 'siteAddress',
    title: 'Site Address',
    width: 250,
    isMandatory: 'Y',
    sorter: true,
  },
  {
    id: 4,
    dataIndex: 'siteCity',
    key: 'siteCity',
    title: 'Site City',
    isMandatory: 'Y',
    width: 150,
    sorter: true,
  },
  {
    id: 5,
    dataIndex: 'siteState',
    key: 'siteState',
    title: 'Site State',
    isMandatory: 'Y',
    width: 150,
    sorter: true,
  },
  {
    id: 6,
    dataIndex: 'zip',
    key: 'zip',
    title: 'Site Zip',
    isMandatory: 'Y',
    width: 150,
    sorter: true,
  },
  {
    id: 16,
    dataIndex: 'siteDea',
    key: 'siteDea',
    title: 'Site DEA',
    isMandatory: 'Y',
    width: 150,
    sorter: true,
  },
  {
    id: 14,
    dataIndex: 'siteHin',
    key: 'siteHin',
    title: 'Site HIN',
    isMandatory: 'Y',
    width: 150,
    sorter: true,
  },

  {
    id: 15,
    dataIndex: 'siteClassification',
    key: 'siteClassification',
    title: 'Site Classification',
    isMandatory: 'Y',
    width: 250,
    sorter: true,
  },
  {
    id: 1,
    title: 'Site ID',
    dataIndex: 'siteId',
    key: 'siteId',
    isMandatory: 'Y',
    width: 250,
    sorter: true,
  },
  {
    id: 8,
    dataIndex: 'hcpId',
    key: 'siteId',
    title: 'Stakeholder ID',
    isMandatory: 'N',
    width: 150,
    sorter: true,
  },
];

export const SITE_INFO_AFFILIATIONS_COLUMNS = [
  {
    id: 1,
    title: 'Stakeholder Name',
    dataIndex: 'hcpName',
    key: 'hcpNameSite',
    isMandatory: 'Y',
    width: 220,
    sorter: true,
    defaultSortOrder: 'ascend',
  },
  {
    id: 2,
    dataIndex: 'hcpPrimarySpeciality',
    key: 'hcpSpecialitySite',
    title: 'Primary Speciality',
    isMandatory: 'Y',
    width: 210,
    sorter: true,
  },
  {
    id: 3,
    dataIndex: 'hcpSecondarySpeciality',
    key: 'hcpSecondarySpecialitySite',
    title: 'Secondary Speciality',
    isMandatory: 'Y',
    width: 210,
    sorter: true,
  },
  {
    id: 4,
    dataIndex: 'hcpCity',
    key: 'hcpCitySite',
    title: 'City',
    isMandatory: 'Y',
    width: 160,
    sorter: true,
  },
  {
    id: 5,
    dataIndex: 'hcpState',
    key: 'hcpStateSite',
    title: 'State',
    isMandatory: 'Y',
    width: 100,
    sorter: true,
  },
  {
    id: 6,
    dataIndex: 'hcpZip',
    key: 'hcpZipSite',
    title: 'Zip',
    isMandatory: 'Y',
    width: 100,
    sorter: true,
  },
];

export const SITE_AFFILIATIONS_COLUMNS = [
  {
    id: 1,
    title: 'Stakeholder Name',
    dataIndex: 'hcpName',
    key: 'hcpNameSite',
    isMandatory: 'Y',
    width: 200,
    sorter: true,
    defaultSortOrder: 'ascend',
  },
  {
    id: 11,
    title: 'Stakeholder Type',
    dataIndex: 'stakeholderType',
    key: 'stakeholderType',
    isMandatory: 'Y',
    width: 200,
    sorter: true,
  },

  {
    id: 2,
    dataIndex: 'hcpSpeciality',
    key: 'hcpSpecialitySite',
    title: 'Speciality',
    isMandatory: 'Y',
    width: 200,
    sorter: true,
  },
  {
    id: 3,
    dataIndex: 'hcpAddress',
    key: 'hcpAddressSite',
    title: 'Stakeholder Address',
    width: 200,
    isMandatory: 'Y',
    sorter: true,
  },
  {
    id: 4,
    dataIndex: 'hcpCity',
    key: 'hcpCitySite',
    title: 'Stakeholder City',
    isMandatory: 'Y',
    width: 150,
    sorter: true,
  },
  {
    id: 5,
    dataIndex: 'hcpState',
    key: 'hcpStateSite',
    title: 'Stakeholder State',
    isMandatory: 'Y',
    width: 180,
    sorter: true,
  },
  {
    id: 6,
    dataIndex: 'hcpZip',
    key: 'hcpZipSite',
    title: 'Stakeholder Zip',
    isMandatory: 'Y',
    width: 150,
    sorter: true,
  },
  {
    id: 9,
    dataIndex: 'hcpPrimarySpeciality',
    key: 'hcpPrimarySpecialitySite',
    title: 'Primary Speciality',
    width: 200,
    isMandatory: 'Y',
    sorter: true,
  },
  {
    id: 10,
    dataIndex: 'hcpSecondarySpeciality',
    key: 'hcpSecondarySpecialitySite',
    title: 'Secondary Speciality',
    isMandatory: 'Y',
    width: 200,
    sorter: true,
  },
];

export const SITE_PERFOMANCE_COLUMNS = [
  {
    id: 2,
    dataIndex: 'siteName',
    key: 'siteName',
    title: 'Site Name',
    isMandatory: 'Y',
    width: 180,
    sorter: true,
  },
  {
    id: 3,
    dataIndex: 'siteAddress',
    key: 'siteAddress',
    title: 'Site Address',
    isMandatory: 'Y',
    width: 180,
    sorter: true,
  },
  {
    id: 4,
    dataIndex: 'siteCity',
    key: 'siteCity',
    title: 'Site City',
    isMandatory: 'Y',
    width: 110,
    sorter: true,
  },
  {
    id: 5,
    dataIndex: 'siteState',
    key: 'siteState',
    title: 'Site State',
    isMandatory: 'Y',
    width: 110,
    sorter: true,
  },
  {
    id: 9,
    dataIndex: 'ecosystem',
    key: 'ecosystem',
    title: 'Ecosystem',
    isMandatory: 'Y',
    width: 115,
    sorter: true,
  },
  {
    id: 7,
    dataIndex: 'contractSegment',
    key: 'contractSegment',
    title: 'Contract Segment',
    isMandatory: 'Y',
    width: 170,
    sorter: true,
  },
  {
    id: 6,
    dataIndex: 'classOfTrade',
    key: 'classOfTrade',
    title: 'Class of Trade',
    isMandatory: 'Y',
    width: 150,
    sorter: true,
  },
  {
    id: 11,
    dataIndex: 'percentOfCP',
    key: 'percentOfCP',
    title: '% Of CP',
    isMandatory: 'Y',
    width: 110,
    render: (value) => {
      const formattedNumber = Number(value).toFixed(2) + '%';
      return <span>{formattedNumber}</span>;
    },
    sorter: true,
  },
  {
    id: 12,
    dataIndex: 'grossSales',
    key: 'grossSales',
    title: 'Gross Sales($)',
    isMandatory: 'Y',
    width: 150,
    render: (value) => {
      const formattedNumber =
        '$' +
        Number(value).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      return <span>{formattedNumber}</span>;
    },
    sorter: true,
    defaultSortOrder: 'descend',
  },
  {
    id: 13,
    dataIndex: 'grossSalesGrowth',
    key: 'grossSalesGrowth',
    title: 'Gross Sales Growth %',
    isMandatory: 'Y',
    width: 150,
    render: (value) => {
      const formattedNumber = `${Number(value).toFixed(2)}%`;
      const numberColor = value < 0 ? '#d04715' : '#74AA50';
      return <span style={{ color: numberColor }}>{formattedNumber}</span>;
    },
    sorter: true,
  },
  {
    id: 1,
    title: 'Site ID',
    dataIndex: 'siteId',
    key: 'siteId',
    isMandatory: 'Y',
    width: 140,
    sorter: true,
  },
  {
    id: 14,
    title: '340B ID',
    dataIndex: '340B_ID',
    key: '340B_ID',
    isMandatory: 'Y',
    width: 140,
    sorter: true,
  },
];

export const SITE_UTILIZATION_UTILIZATION = [
  {
    id: 1,
    dataIndex: 'ecosystem',
    key: 'ecosystem',
    title: 'Ecosystem',
    isMandatory: 'Y',
    width: 180,
    sorter: true,
    fixed: 'left',
    qFieldDefs: ['Ecosystem'],
  },
  {
    id: 2,
    dataIndex: 'site_name',
    key: 'site_name',
    title: 'Site Name',
    isMandatory: 'Y',
    width: 180,
    sorter: true,
    fixed: 'left',
    qFieldDefs: ['Site Name'],
  },
  {
    id: 3,
    dataIndex: 'site_address',
    key: 'siteAddress',
    title: 'Site Address',
    isMandatory: 'Y',
    width: 180,
    sorter: true,
    fixed: 'left',
    qFieldDefs: ['Site Address'],
  },
  {
    id: 4,
    dataIndex: 'site_city',
    key: 'siteCity',
    title: 'Site City',
    isMandatory: 'Y',
    sorter: true,
    width: 180,
    qFieldDefs: ['Site City'],
  },
  {
    id: 5,
    dataIndex: 'site_state',
    key: 'siteState',
    title: 'Site State',
    isMandatory: 'Y',
    sorter: true,
    width: 130,
    qFieldDefs: ['Site State'],
  },
  {
    id: 6,
    dataIndex: 'site_zip',
    key: 'siteZip',
    title: 'Site Zip',
    isMandatory: 'Y',
    sorter: true,
    width: 130,
    qFieldDefs: ['Site Zip'],
  },
  {
    id: 7,
    dataIndex: 'size',
    key: 'size',
    title: 'Size',
    isMandatory: 'Y',
    sorter: true,
    width: 130,
    qFieldDefs: ['Size'],
  },
  {
    id: 8,
    dataIndex: 'summary_score',
    key: 'summaryScore',
    title: 'Summary Score',
    isMandatory: 'Y',
    sorter: (a, b) => a?.summary_score - b?.summary_score,
    defaultSortOrder: 'descend',
    width: 160,
    qFieldDefs: ['Summary Score'],
  },
  {
    id: 9,
    dataIndex: 'actemra_iv',
    key: 'actemraIv',
    title: 'ACTEMRA IV',
    isMandatory: 'Y',
    sorter: true,
    qFieldDefs: ['ACTEMRA IV'],
  },
  {
    id: 10,
    dataIndex: 'actemra_sc',
    key: 'actemraSc',
    title: 'ACTEMRA SC',
    isMandatory: 'Y',
    sorter: true,
    qFieldDefs: ['ACTEMRA SC'],
  },
  {
    id: 11,
    dataIndex: 'alecensa',
    key: 'alecensa',
    title: 'ALECENSA',
    isMandatory: 'Y',
    sorter: true,
    qFieldDefs: ['ALECENSA'],
  },
  {
    id: 12,
    dataIndex: 'avastin',
    key: 'avastin',
    title: 'AVASTIN',
    isMandatory: 'Y',
    sorter: true,
    qFieldDefs: ['AVASTIN'],
  },
  {
    id: 13,
    dataIndex: 'columvi',
    key: 'columvi',
    title: 'COLUMVI',
    isMandatory: 'Y',
    sorter: true,
    qFieldDefs: ['COLUMVI'],
  },
  {
    id: 14,
    dataIndex: 'enspryng',
    key: 'enspryng',
    title: 'ENSPRYNG',
    isMandatory: 'Y',
    sorter: true,
    qFieldDefs: ['ENSPRYNG'],
  },
  {
    id: 15,
    dataIndex: 'evrysdi',
    key: 'evrysdi',
    title: 'EVRYSDI',
    isMandatory: 'Y',
    sorter: true,
    qFieldDefs: ['EVRYSDI'],
  },
  {
    id: 16,
    dataIndex: 'gavreto',
    key: 'gavreto',
    title: 'GAVRETO',
    isMandatory: 'Y',
    sorter: true,
    qFieldDefs: ['GAVRETO'],
  },
  {
    id: 17,
    dataIndex: 'gazyva',
    key: 'gazyva',
    title: 'GAZYVA',
    isMandatory: 'Y',
    sorter: true,
    qFieldDefs: ['GAZYVA'],
  },
  {
    id: 18,
    dataIndex: 'hemlibra',
    key: 'hemlibra',
    title: 'HEMLIBRA',
    isMandatory: 'Y',
    sorter: true,
    qFieldDefs: ['HEMLIBRA'],
  },
  {
    id: 19,
    dataIndex: 'herceptin',
    key: 'herceptin',
    title: 'HERCEPTIN',
    isMandatory: 'Y',
    sorter: true,
    qFieldDefs: ['HERCEPTIN'],
  },
  {
    id: 20,
    dataIndex: 'herceptin_hylecTA',
    key: 'herceptinHylecta',
    title: 'HERCEPTIN HYLECTA',
    isMandatory: 'Y',
    sorter: true,
    width: 180,
    qFieldDefs: ['HERCEPTIN HYLECTA'],
  },
  {
    id: 21,
    dataIndex: 'itovebi',
    key: 'itovebi',
    title: 'ITOVEBI',
    isMandatory: 'Y',
    sorter: true,
    qFieldDefs: ['ITOVEBI'],
  },
  {
    id: 22,
    dataIndex: 'kadcyla',
    key: 'kadcyla',
    title: 'KADCYLA',
    isMandatory: 'Y',
    sorter: true,
    qFieldDefs: ['KADCYLA'],
  },
  {
    id: 23,
    dataIndex: 'lucentis',
    key: 'lucentis',
    title: 'LUCENTIS',
    isMandatory: 'Y',
    sorter: true,
    qFieldDefs: ['LUCENTIS'],
  },
  {
    id: 24,
    dataIndex: 'lunsumio',
    key: 'lunsumio',
    title: 'LUNSUMIO',
    isMandatory: 'Y',
    sorter: true,
    qFieldDefs: ['LUNSUMIO'],
  },
  {
    id: 25,
    dataIndex: 'ocrevus',
    key: 'ocrevus',
    title: 'OCREVUS',
    isMandatory: 'Y',
    sorter: true,
    qFieldDefs: ['OCREVUS'],
  },
  {
    id: 26,
    dataIndex: 'perjeta',
    key: 'perjeta',
    title: 'PERJETA',
    isMandatory: 'Y',
    sorter: true,
    qFieldDefs: ['PERJETA'],
  },
  {
    id: 27,
    dataIndex: 'phesgo',
    key: 'phesgo',
    title: 'PHESGO',
    isMandatory: 'Y',
    sorter: true,
    qFieldDefs: ['PHESGO'],
  },
  {
    id: 28,
    dataIndex: 'polivy',
    key: 'polivy',
    title: 'POLIVY',
    isMandatory: 'Y',
    sorter: true,
    qFieldDefs: ['POLIVY'],
  },
  {
    id: 29,
    dataIndex: 'rituxan',
    key: 'rituxan',
    title: 'RITUXAN',
    isMandatory: 'Y',
    sorter: true,
    qFieldDefs: ['RITUXAN'],
  },
  {
    id: 30,
    dataIndex: 'rituxan_hycela',
    key: 'rituxanHycela',
    title: 'RITUXAN HYCELA',
    isMandatory: 'Y',
    sorter: true,
    width: 180,
    qFieldDefs: ['RITUXAN HYCELA'],
  },
  {
    id: 31,
    dataIndex: 'rozlytrek',
    key: 'rozlytrek',
    title: 'ROZLYTREK',
    isMandatory: 'Y',
    sorter: true,
    qFieldDefs: ['ROZLYTREK'],
  },
  {
    id: 32,
    dataIndex: 'tecentriq',
    key: 'tecentriq',
    title: 'TECENTRIQ',
    isMandatory: 'Y',
    sorter: true,
    qFieldDefs: ['TECENTRIQ'],
  },
  {
    id: 33,
    dataIndex: 'vabysmo',
    key: 'vabysmo',
    title: 'VABYSMO',
    isMandatory: 'Y',
    sorter: true,
    qFieldDefs: ['VABYSMO'],
  },
  {
    id: 34,
    dataIndex: 'venclexta',
    key: 'venclexta',
    title: 'VENCLEXTA',
    isMandatory: 'Y',
    sorter: true,
    qFieldDefs: ['VENCLEXTA'],
  },
  {
    id: 35,
    dataIndex: 'xolair',
    key: 'xolair',
    title: 'XOLAIR',
    isMandatory: 'Y',
    sorter: true,
    qFieldDefs: ['XOLAIR'],
  },
  {
    id: 1,
    title: 'Site ID',
    dataIndex: 'site_id',
    key: 'site_id',
    isMandatory: 'Y',
    sorter: true,
    width: 180,
    qFieldDefs: ['Site ID'],
  },
];

export const SITE_UTILIZATION_INCIDENCE = [
  {
    id: 1,
    dataIndex: 'ecosystem',
    key: 'ecosystem',
    title: 'Ecosystem',
    isMandatory: 'Y',
    width: 180,
    sorter: true,
    fixed: 'left',
    qFieldDefs: ['Ecosystem'],
  },
  {
    id: 2,
    dataIndex: 'site_name',
    key: 'site_name',
    title: 'Site Name',
    isMandatory: 'Y',
    width: 180,
    sorter: true,
    fixed: 'left',
    qFieldDefs: ['Site Name'],
  },
  {
    id: 3,
    dataIndex: 'site_address',
    key: 'siteAddress',
    title: 'Site Address',
    isMandatory: 'Y',
    width: 180,
    sorter: true,
    fixed: 'left',
    qFieldDefs: ['Site Address'],
  },
  {
    id: 4,
    dataIndex: 'site_city',
    key: 'siteCity',
    title: 'Site City',
    isMandatory: 'Y',
    sorter: true,
    width: 180,
    qFieldDefs: ['Site City'],
  },
  {
    id: 5,
    dataIndex: 'site_state',
    key: 'siteState',
    title: 'Site State',
    isMandatory: 'Y',
    sorter: true,
    width: 130,
    qFieldDefs: ['Site State'],
  },
  {
    id: 6,
    dataIndex: 'site_zip',
    key: 'siteZip',
    title: 'Site Zip',
    isMandatory: 'Y',
    sorter: true,
    width: 130,
    qFieldDefs: ['Site Zip'],
  },
  {
    id: 7,
    dataIndex: 'size',
    key: 'size',
    title: 'Size',
    isMandatory: 'Y',
    sorter: true,
    width: 130,
    qFieldDefs: ['Size'],
  },
  {
    id: 8,
    dataIndex: 'summary_score',
    key: 'summaryScore',
    title: 'Summary Score',
    isMandatory: 'Y',
    defaultSortOrder: 'descend',
    sorter: (a, b) => a?.summary_score - b?.summary_score,
    width: 130,
    qFieldDefs: ['Summary Score'],
  },
  {
    id: 9,
    dataIndex: 'breast_category',
    key: 'actemraIv',
    title: 'Breast (Category)',
    isMandatory: 'Y',
    width: 130,
    sorter: true,
    qFieldDefs: ['Breast_Category'],
  },
  {
    id: 10,
    dataIndex: 'breast_per_100K',
    key: 'actemraSc',
    title: 'Breast (# per 100K)',
    isMandatory: 'Y',
    width: 130,
    sorter: true,
    qFieldDefs: ['Breast_per_100K'],
  },
  {
    id: 11,
    dataIndex: 'lung_category',
    key: 'alecensa',
    title: 'Lung (Category)',
    isMandatory: 'Y',
    width: 130,
    sorter: true,
    qFieldDefs: ['Lung_Category'],
  },
  {
    id: 12,
    dataIndex: 'lung_per_100K',
    key: 'avastin',
    title: 'Lung (# per 100K)',
    isMandatory: 'Y',
    width: 130,
    sorter: true,
    qFieldDefs: ['Lung_per_100K'],
  },
  {
    id: 13,
    dataIndex: 'leukemia_category',
    key: 'columvi',
    title: 'Leukemia (Category)',
    isMandatory: 'Y',
    width: 130,
    sorter: true,
    qFieldDefs: ['Leukemia_Category'],
  },
  {
    id: 14,
    dataIndex: 'leukemia_per_100K',
    key: 'gazyva',
    title: 'Leukemia (# per 100K)',
    isMandatory: 'Y',
    width: 130,
    sorter: true,
    qFieldDefs: ['Leukemia_per_100K'],
  },
  {
    id: 15,
    dataIndex: 'lymphoma_category',
    key: 'hemlibra',
    title: 'Lymphoma (Category)',
    isMandatory: 'Y',
    width: 130,
    sorter: true,
    qFieldDefs: ['Lymphoma_Category'],
  },
  {
    id: 16,
    dataIndex: 'lymphoma_per_100K',
    key: 'herceptin',
    title: 'Lymphoma (# per 100K)',
    isMandatory: 'Y',
    width: 130,
    sorter: true,
    qFieldDefs: ['Lymphoma_per_100K'],
  },
  {
    id: 1,
    width: 180,
    title: 'Site ID',
    dataIndex: 'site_id',
    key: 'site_id',
    isMandatory: 'Y',
    sorter: true,
    qFieldDefs: ['Site ID'],
  },
];

export const SITE_UTILIZATION_DEMOGRAPHICS = [
  {
    id: 1,
    dataIndex: 'ecosystem',
    key: 'ecosystem',
    title: 'Ecosystem',
    isMandatory: 'Y',
    width: 180,
    sorter: true,
    fixed: 'left',
    qFieldDefs: ['Ecosystem'],
  },
  {
    id: 2,
    dataIndex: 'site_name',
    key: 'site_name',
    title: 'Site Name',
    isMandatory: 'Y',
    width: 180,
    sorter: true,
    fixed: 'left',
    qFieldDefs: ['Site Name'],
  },
  {
    id: 3,
    dataIndex: 'site_address',
    key: 'siteAddress',
    title: 'Site Address',
    isMandatory: 'Y',
    sorter: true,
    fixed: 'left',
    width: 180,
    qFieldDefs: ['Site Address'],
  },
  {
    id: 4,
    dataIndex: 'site_city',
    key: 'siteCity',
    title: 'Site City',
    isMandatory: 'Y',
    sorter: true,
    width: 180,
    qFieldDefs: ['Site City'],
  },
  {
    id: 5,
    dataIndex: 'site_state',
    key: 'siteState',
    title: 'Site State',
    isMandatory: 'Y',
    sorter: true,
    width: 130,
    qFieldDefs: ['Site State'],
  },
  {
    id: 6,
    dataIndex: 'site_zip',
    key: 'siteZip',
    title: 'Site Zip',
    isMandatory: 'Y',
    sorter: true,
    width: 130,
    qFieldDefs: ['Site Zip'],
  },
  {
    id: 7,
    dataIndex: 'size',
    key: 'size',
    title: 'Size',
    isMandatory: 'Y',
    sorter: true,
    width: 130,
    qFieldDefs: ['Size'],
  },
  {
    id: 8,
    dataIndex: 'summary_score',
    key: 'summaryScore',
    title: 'Summary Score',
    isMandatory: 'Y',
    sorter: (a, b) => a?.summary_score - b?.summary_score,
    defaultSortOrder: 'descend',
    width: 130,
    qFieldDefs: ['Summary Score'],
  },
  {
    id: 9,
    dataIndex: 'zip_population',
    key: 'actemraIv',
    title: 'Zip Population',
    isMandatory: 'Y',
    sorter: true,
    width: 130,
    qFieldDefs: ['Zip Population'],
  },
  {
    id: 10,
    dataIndex: 'HHS_below_poverty_category',
    key: 'actemraSc',
    title: 'HHS Below Poverty (Category)',
    isMandatory: 'Y',
    width: 130,
    sorter: true,
    qFieldDefs: ['HHS_Below_Poverty_Category'],
  },
  {
    id: 11,
    dataIndex: 'HHS_below_poverty',
    key: 'alecensa',
    title: 'HHS Below Poverty (%)',
    isMandatory: 'Y',
    width: 130,
    sorter: true,
    qFieldDefs: ['HHS_Below_Poverty_Pct'],
  },
  {
    id: 12,
    dataIndex: 'no_insurance_category',
    key: 'avastin',
    title: 'No Insurance (Category)',
    isMandatory: 'Y',
    width: 130,
    sorter: true,
    qFieldDefs: ['No_Insurance_Category'],
  },
  {
    id: 13,
    dataIndex: 'no_insurance',
    key: 'columvi',
    title: 'No Insurance (%)',
    isMandatory: 'Y',
    width: 130,
    sorter: true,
    qFieldDefs: ['No_Insurance_Pct'],
  },
  {
    id: 14,
    dataIndex: 'commercial',
    key: 'gazyva',
    title: 'Commercial (%)',
    isMandatory: 'Y',
    width: 130,
    sorter: true,
    qFieldDefs: ['Commercial_Pct'],
  },
  {
    id: 15,
    dataIndex: 'medicare',
    key: 'hemlibra',
    title: 'Medicare (%)',
    isMandatory: 'Y',
    width: 130,
    sorter: true,
    qFieldDefs: ['Medicare_Pct'],
  },
  {
    id: 16,
    dataIndex: 'medicaid',
    key: 'herceptin',
    title: 'MedicaId (%)',
    isMandatory: 'Y',
    width: 130,
    sorter: true,
    qFieldDefs: ['Medicaid_Pct'],
  },
  {
    id: 31,
    title: 'Site ID',
    dataIndex: 'site_id',
    key: 'site_id',
    isMandatory: 'Y',
    sorter: true,
    width: 180,
    qFieldDefs: ['Site ID'],
  },
];
export const SITE_UTILIZATION_COLUMNS = Array.from(
  new Set(
    [
      ...SITE_UTILIZATION_UTILIZATION,
      ...SITE_UTILIZATION_INCIDENCE,
      ...SITE_UTILIZATION_DEMOGRAPHICS,
    ].map((item) => item.dataIndex)
  )
).map((dataIndex) => {
  const mergedObject = {};
  [
    SITE_UTILIZATION_UTILIZATION,
    SITE_UTILIZATION_INCIDENCE,
    SITE_UTILIZATION_DEMOGRAPHICS,
  ].forEach((array) => {
    const foundObject = array.find((item) => item.dataIndex === dataIndex);
    if (foundObject) {
      Object.assign(mergedObject, foundObject);
    }
  });
  return mergedObject;
});

export const updatedKpiNameLength = 250;
export const kpiTitleMessage = 'Title updated successfully.';
export const kpiTitleLimitExceedMessage =
  'Title name is exceeding the limit - 250 characters.';

export const PRODUCT_MIX_COLUMNS = [
  {
    id: 1,
    title: 'Product',
    dataIndex: 'product',
    key: 'product',
    isMandatory: 'Y',
    width: 280,
    sorter: true,
  },
  {
    id: 2,
    dataIndex: 'grossSales',
    key: 'grossSales',
    title: 'Sales ($)',
    isMandatory: 'Y',
    width: 270,
    render: (value) => {
      if (value === '-') {
        return '-';
      } else {
        const formattedNumber =
          '$' +
          Number(value).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
        return <span>{formattedNumber}</span>;
      }
    },
    sorter: true,
    defaultSortOrder: 'descend',
  },
  {
    id: 4,
    dataIndex: 'grossSalesGrowthProduct',
    key: 'grossSalesGrowthProduct',
    title: 'Sales Growth %',
    isMandatory: 'Y',
    width: 280,
    render: (value) => {
      if (value === '-') {
        return '-';
      } else {
        const formattedNumber = `${Number(value).toFixed(2)}%`;
        const numberColor = value < 0 ? '#d04715' : '#74AA50';
        return <span style={{ color: numberColor }}>{formattedNumber}</span>;
      }
    },
    sorter: true,
  },
  {
    id: 3,
    dataIndex: 'percentOfCPProduct',
    key: 'percentOfCPProduct',
    title: '% Contribution',
    isMandatory: 'Y',
    width: 230,
    render: (value) => {
      if (value === '-') {
        return '-';
      } else {
        const formattedNumber = Number(value).toFixed(2) + '%';
        return <span>{formattedNumber}</span>;
      }
    },
    sorter: true,
  },
];

export const COPAY_ANALYTICS_COLUMNS = [
  {
    id: 1,
    title: 'Product',
    dataIndex: 'Product',
    key: 'Product',
    isMandatory: 'Y',
    width: 250,
    sorter: true,
    columnVisibility: ColumnVisiblity.Default,
  },

  {
    id: 2,
    dataIndex: 'Quarter',
    key: 'Quarter',
    title: 'Quarter',
    isMandatory: 'Y',
    sorter: true,
    width: 150,
    columnVisiblity: ColumnVisiblity.Optional,
  },
  {
    id: 3,
    dataIndex: 'Site',
    key: 'Site',
    title: 'Site Name',
    isMandatory: 'Y',
    width: 300,
    sorter: true,
    columnVisiblity: ColumnVisiblity.Optional,
  },
  {
    id: 4,
    dataIndex: 'Site Full Address',
    key: 'Site Full Address',
    title: 'Site Address',
    isMandatory: 'Y',
    width: 300,
    sorter: true,
    columnVisiblity: ColumnVisiblity.Optional,
  },
  {
    id: 5,
    dataIndex: 'site_city',
    key: 'site_city',
    title: 'Site City',
    isMandatory: 'Y',
    width: 200,
    sorter: true,
    columnVisiblity: ColumnVisiblity.Optional,
  },
  {
    id: 6,
    dataIndex: 'site_state',
    key: 'site_state',
    title: 'Site State',
    isMandatory: 'Y',
    width: 150,
    sorter: true,
    columnVisiblity: ColumnVisiblity.Optional,
  },
  {
    id: 7,
    dataIndex: 'Site_INS_ID',
    key: 'Site_INS_ID',
    title: 'Site ID',
    isMandatory: 'Y',
    width: 300,
    sorter: true,
    columnVisiblity: ColumnVisiblity.Optional,
  },
  {
    id: 8,
    dataIndex: 'New Enrollment',
    key: 'NewEnrollment',
    title: 'New Enrollment',
    isMandatory: 'Y',
    width: 200,
    sorter: true,
    columnVisiblity: ColumnVisiblity.Mandatory,
  },
  {
    id: 9,
    dataIndex: 'Total Enrollment',
    key: 'TotalEnrollment',
    title: 'Total Enrollment',
    isMandatory: 'Y',
    width: 200,
    sorter: true,
    columnVisiblity: ColumnVisiblity.Mandatory,
  },
  {
    id: 10,
    dataIndex: 'Total Paid Claims',
    key: 'TotalPaidClaims',
    title: 'Total Paid Claims',
    isMandatory: 'Y',
    width: 200,
    sorter: true,
    defaultSortOrder: 'descend',
    columnVisiblity: ColumnVisiblity.Mandatory,
  },
  {
    id: 11,
    dataIndex: 'Unique Utilizers',
    key: 'UniqueUtilizers',
    title: 'Unique Utilizers(Patients)',
    isMandatory: 'Y',
    width: 200,
    sorter: true,
    columnVisiblity: ColumnVisiblity.Mandatory,
  },
];

export const RelativeAccessPossition = {
  Disadvantaged: 'Disadvantaged',
  Parity: 'Parity',
  Advantaged: 'Advantaged',
};

export const PAYER_MIX_COLUMNS = [
  {
    id: 1,
    title: 'MDM Parent Payer ID',
    dataIndex: 'parentPayerMdmId',
    key: 'ParentPayerMdmId',
    isMandatory: 'Y',
    width: 180,
    sorter: true,
    fixed: 'left',
    columnVisiblity: ColumnVisiblity.Optional,
    render: (value, record) => {
      return <span>{record?.parentPayer?.mdmId}</span>;
    },
  },
  {
    id: 2,
    title: 'Parent Payer',
    dataIndex: 'parentPayer',
    key: 'ParentPayerName',
    isMandatory: 'Y',
    width: 220,
    sorter: true,
    fixed: 'left',
    columnVisiblity: ColumnVisiblity.Mandatory,
    render: (value) => {
      return <span>{value?.entityName}</span>;
    },
  },
  {
    id: 3,
    title: 'MDM Payer ID',
    dataIndex: 'payerMdmId',
    key: 'PayerMdmId',
    isMandatory: 'Y',
    width: 180,
    sorter: true,
    fixed: 'left',
    columnVisiblity: ColumnVisiblity.Optional,
    render: (value, record) => {
      return <span>{record?.payer?.mdmId}</span>;
    },
  },
  {
    id: 4,
    dataIndex: 'payer',
    key: 'PayerName',
    title: 'Payer',
    isMandatory: 'Y',
    width: 220,
    sorter: true,
    fixed: 'left',
    columnVisiblity: ColumnVisiblity.Mandatory,
    render: (value) => {
      return <span>{value?.entityName}</span>;
    },
  },
  {
    id: 5,
    dataIndex: 'bookOfBusiness',
    key: 'BookOfBusiness',
    title: 'Book of Business',
    isMandatory: 'Y',
    width: 160,
    sorter: true,
    columnVisiblity: ColumnVisiblity.Mandatory,
  },
  {
    id: 6,
    dataIndex: 'benefitType',
    key: 'BenefitType',
    title: 'Benefit Type',
    isMandatory: 'Y',
    width: 160,
    sorter: true,
    columnVisiblity: ColumnVisiblity.Mandatory,
  },
  {
    id: 7,
    dataIndex: 'entitySales',
    key: 'EntitySales',
    label: 'Estimated Payer Sales ($)', // Will be used in Setting popupover
    title: renderTitleTooltip(
      'Estimated Payer Sales ($)',
      'Estimated Payer Sales (R12M) is a calculated metric leveraging Lives, Product Sales and Product Book of Business mix. This metric is affected by Product, Book of Business, Ecosystem, and Benefit Type. This metric is NOT affected by Indication.'
    ),
    isMandatory: 'Y',
    width: 150,
    render: (value) => {
      const formattedNumber =
        '$' +
        Number(value).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      return <span>{formattedNumber}</span>;
    },
    sorter: true,
    columnVisiblity: ColumnVisiblity.Default,
  },
  {
    id: 8,
    dataIndex: 'payerContributionToAccount',
    key: 'PayerContributionToAccount',
    label: 'Estimated Contribution to Account (%)',
    title: renderTitleTooltip(
      'Estimated Contribution to Account (%)',
      "This metric shows the Payer's contribution to the Account imputed sales over R12M. This metric is affected by Product, Book of Business, Benefit Type, and Ecosystem. This metric is NOT affected by Indication."
    ),
    isMandatory: 'Y',
    width: 200,
    render: (value) => {
      if (value === '-' || value === undefined) {
        return '-';
      } else {
        const formattedNumber = Number(value).toFixed(2) + '%';
        return <span>{formattedNumber}</span>;
      }
    },
    sorter: true,
    defaultSortOrder: 'descend',
    columnVisiblity: ColumnVisiblity.Default,
  },
  {
    id: 9,
    dataIndex: 'policyStatus',
    key: 'PolicyStatus',
    label: 'Policy Status',
    title: 'Policy Status',
    isMandatory: 'Y',
    width: 160,
    sorter: true,
    columnVisiblity: ColumnVisiblity.Default,
  },
  {
    id: 10,
    dataIndex: 'compBrandPolicyStatus',
    key: 'CompBrandPolicyStatus',
    label: 'Competitor Brand Policy Status',
    title: 'Competitor Brand Policy Status',
    isMandatory: 'Y',
    width: 160,
    sorter: true,
    columnVisiblity: ColumnVisiblity.Default,
  },
  {
    id: 11,
    dataIndex: 'accessPosition',
    key: 'AccessPosition',
    label: 'Relative Access Position',
    title: renderTitleTooltip(
      'Relative Access Position',
      'Select Competitor Brand to populate access position'
    ),
    isMandatory: 'Y',
    width: 230,
    sorter: true,
    render: (text, record) => {
      const accessPossitions = Object.values(RelativeAccessPossition);
      if (!accessPossitions?.includes(text)) return '-';
      return (
        <Tag
          color={
            text === RelativeAccessPossition?.Advantaged
              ? styleVars.color_green
              : text === RelativeAccessPossition?.Parity
                ? styleVars.color_yellow_2
                : text === RelativeAccessPossition?.Disadvantaged
                  ? styleVars.color_red_2
                  : ''
          }>
          {text}
        </Tag>
      );
    },
    columnVisiblity: ColumnVisiblity.Default,
  },
  {
    id: 13,
    dataIndex: 'paRequired',
    key: 'PARequired',
    label: 'PA Required',
    title: renderTitleTooltip('PA Required', 'Prior Authorization Required'),
    isMandatory: 'Y',
    width: 170,
    sorter: true,
    columnVisiblity: ColumnVisiblity.Default,
  },
  {
    id: 14,
    dataIndex: 'stepEdits',
    key: 'StepEdits',
    label: 'Step Edit',
    title: renderTitleTooltip(
      'Step Edit',
      'Is the patient required to use a different brand before they can start using the selected GNE brand?'
    ),
    isMandatory: 'Y',
    width: 170,
    sorter: true,
    columnVisiblity: ColumnVisiblity.Default,
  },
  {
    id: 15,
    dataIndex: 'stepProducts',
    key: 'StepProducts',
    label: 'Step Brand',
    title: renderTitleTooltip(
      'Step Brand',
      'If Step Edits are in place, which brand(s) is the patient required to use prior to the selected GNE brand?'
    ),
    isMandatory: 'Y',
    width: 250,
    sorter: true,
    columnVisiblity: ColumnVisiblity.Default,
  },
  {
    id: 16,
    dataIndex: 'statusOverwrite',
    key: 'StatusOverwrite',
    label: 'Policy Status Overwritten',
    title: renderTitleTooltip(
      'Policy Status Overwritten',
      'This flag indicates if the policy data has been overwritten through Policy Intelligence.'
    ),
    isMandatory: 'Y',
    width: 150,
    sorter: true,
    columnVisiblity: ColumnVisiblity.Optional,
  },
  {
    id: 17,
    dataIndex: 'policyUpdateURL',
    key: 'PolicyUpdateURL',
    label: 'Policy Intelligence Update Form',
    title: renderTitleTooltip(
      'Policy Intelligence Update Form',
      'In case any policy related data may be incorrect, please use this link to submit a data change request.'
    ),
    isMandatory: 'Y',
    width: 270,
    sorter: true,
    columnVisiblity: ColumnVisiblity.Mandatory,
  },
];

export const DOCUMENT_COLUMNS = [
  {
    id: 1,
    dataIndex: 'name',
    key: 'name',
    title: 'Document Name',
    isMandatory: 'Y',
    width: 150,
    sorter: (a, b) => a.name.localeCompare(b.name),
    defaultSortOrder: 'ascend',
    render: (_, record) => (
      <OverlayTrigger
        overlay={documentTooltip(record?.description)}
        style={{ minWidth: '300px' }}>
        <Link
          to={record.url}
          target='_blank'>
          {record.name}
        </Link>
      </OverlayTrigger>
    ),
  },
  {
    id: 2,
    dataIndex: 'refreshSchedule',
    key: 'refreshSchedule',
    title: 'Refresh Frequency',
    isMandatory: 'Y',
    width: 70,
    sorter: (a, b) => a.refreshSchedule.localeCompare(b.refreshSchedule),
  },
  {
    id: 3,
    dataIndex: 'pointOfContact',
    key: 'pointOfContact',
    title: 'Point of Contact',
    isMandatory: 'Y',
    width: 60,
    sorter: (a, b) => a.pointOfContact.localeCompare(b.pointOfContact),
  },
];
export const TABLE_VIEWS_COLUMNS = [
  {
    id: 1,
    dataIndex: 'name',
    key: 'name',
    title: 'Name',
    isMandatory: 'Y',
    width: 180,
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    id: 2,
    dataIndex: 'owner',
    key: 'owner',
    title: 'Owner',
    isMandatory: 'Y',
    width: 100,
    sorter: (a, b) => a.owner.localeCompare(b.owner),
  },
  {
    id: 3,
    dataIndex: 'createdDate',
    key: 'createdDate',
    title: 'Created Date',
    isMandatory: 'Y',
    width: 130,
    defaultSortOrder: 'descend',
    sorter: (a, b) => new Date(a.createdDate) - new Date(b.createdDate),
  },
];

export const GENERAL_INSIGHT_BOARDS_COLUMNS = [
  {
    id: 1,
    dataIndex: 'name',
    key: 'name',
    title: 'Name',
    isMandatory: 'Y',
    width: 460,
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    id: 2,
    dataIndex: 'createdDate',
    key: 'createdDate',
    title: 'Created',
    isMandatory: 'Y',
    width: 180,
    sorter: (a, b) => new Date(a.createdDate) - new Date(b.createdDate),
    render: (_, record) => (
      <span className='text'>
        <span className='text text__black'>
          {dayjs(record.createdDate).format('MMM DD, YYYY')}
        </span>
      </span>
    ),
  },
  {
    id: 3,
    dataIndex: 'lastViewedDate',
    key: 'lastViewedDate',
    title: 'Last Modified',
    isMandatory: 'Y',
    width: 180,
    defaultSortOrder: 'descend',
    sorter: (a, b) => new Date(a.lastViewedDate) - new Date(b.lastViewedDate),
    render: (_, record) => (
      <span className='text'>
        <span className='text text__black'>
          {dayjs(record.lastViewedDate).format('MMM DD, YYYY')}
        </span>
      </span>
    ),
  },
  {
    id: 4,
    dataIndex: 'boardType',
    key: 'boardType',
    title: 'Customer Type',
    isMandatory: 'Y',
    width: 160,
    sorter: (a, b) => a.boardType.localeCompare(b.boardType),
    render: (_, record) => (
      <span className='text text__black text-capitalize'>
        {record.boardType}
      </span>
    ),
  },
];
export const SAMPLE_INSIGHT_BOARDS_COLUMNS = [
  {
    id: 1,
    dataIndex: 'name',
    key: 'name',
    title: 'Name',
    isMandatory: 'Y',
    width: 350,
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    id: 2,
    dataIndex: 'publisher',
    key: 'publisher',
    title: 'Publisher',
    isMandatory: 'Y',
    width: 230,
    sorter: (a, b) => new Date(a.createdDate) - new Date(b.createdDate),
    render: (_, record) => (
      <span className='text'>
        <span className='text text__black'>{record.owner}</span>
      </span>
    ),
  },
  {
    id: 3,
    dataIndex: 'createdDate',
    key: 'createdDate',
    title: 'Created',
    isMandatory: 'Y',
    width: 230,
    defaultSortOrder: 'descend',
    sorter: (a, b) => new Date(a.createdDate) - new Date(b.createdDate),
    render: (_, record) => (
      <span className='text'>
        <span className='text text__black'>
          {dayjs(record.createdDate).format('MMM DD, YYYY')}
        </span>
      </span>
    ),
  },
  {
    id: 4,
    dataIndex: 'boardType',
    key: 'boardType',
    title: 'Customer Type',
    isMandatory: 'Y',
    width: 160,
    sorter: (a, b) => a.boardType.localeCompare(b.boardType),
    render: (_, record) => (
      <span className='text text__black text-capitalize'>
        {record.boardType}
      </span>
    ),
  },
];
export const OTHER_TOOLS = 'Other Tools';
export const SITE_UTILIZATION_TIME_RANGE_EXP = `only([StartDate]) & ' - ' & Only([EndDate])`;
export const TIME_RANGE_EXP = new Map([
  [
    'R3',
    "Date(AddMonths(Date#(max({1<[Latest Month Flag]={1}>} Date((Date#([Month Year],'YYYYMMDD')),'MM''YYYY')),'MM''YYYY'),-(2)),'MMM''YY')& ' - ' & Date(Date#(max({1<[Latest Month Flag]={1}>} Date((Date#([Month Year],'YYYYMMDD')),'MM''YYYY')),'MM''YYYY'),'MMM''YY')",
  ],
  [
    'R6',
    "Date(AddMonths(Date#(max({1<[Latest Month Flag]={1}>} Date((Date#([Month Year],'YYYYMMDD')),'MM''YYYY')),'MM''YYYY'),-(5)),'MMM''YY')& ' - ' &  Date(Date#(max({1<[Latest Month Flag]={1}>} Date((Date#([Month Year],'YYYYMMDD')),'MM''YYYY')),'MM''YYYY'),'MMM''YY')",
  ],
  [
    'R12',
    "Date(AddMonths(Date#(max({1<[Latest Month Flag]={1}>} Date((Date#([Month Year],'YYYYMMDD')),'MM''YYYY')),'MM''YYYY'),-(11)),'MMM''YY')&' - ' & Date(Date#(max({1<[Latest Month Flag]={1}>} Date((Date#([Month Year],'YYYYMMDD')),'MM''YYYY')),'MM''YYYY'),'MMM''YY')",
  ],
  [
    'YTD',
    "Date(Date#(Min({<YTD={'C'}>} Date((Date#([Month Year],'YYYYMMDD')),'MM''YYYY')),'MM''YYYY'),'MMM''YY') & ' - ' &  Date(Date#(max({1<[Latest Month Flag]={1}>} Date((Date#([Month Year],'YYYYMMDD')),'MM''YYYY')),'MM''YYYY'),'MMM''YY')",
  ],
]);

export const orgHierarchyAllActions = [];
export const PRIORITY_TABLE_COLUMNS = [
  {
    id: 1,
    dataIndex: 'label',
    key: 'label',
    title: 'Name',
    isMandatory: 'Y',
    width: 350,
    sorter: (a, b) => a.label.localeCompare(b.label),
  },
  {
    id: 2,
    dataIndex: 'flag',
    key: 'flag',
    title: 'Type',
    isMandatory: 'Y',
    width: 120,
    sorter: (a, b) => a.flag - b.flag,
    render: (text, record) => (
      <span className='text__capitalize'>{CUSTOMER_TYPE.get(text)}</span>
    ),
  },
  {
    id: 3,
    dataIndex: 'address',
    key: 'address',
    title: 'Address',
    isMandatory: 'Y',
    width: 400,
    sorter: (a, b) => a.address.localeCompare(b.address),
  },
  {
    id: 4,
    dataIndex: 'primaryContact',
    key: 'primaryContact',
    title: 'Primary Contact',
    isMandatory: 'Y',
    width: 180,
    sorter: (a, b) => a.primaryContact.localeCompare(b.primaryContact),
  },
];

export const PAGINATION = {
  pageSizeOptions: [10, 20, 30],
  showSizeChanger: true,
  defaultPageSize: 10,
};

export const SORT_BY = {
  descend: 'DESC',
  ascend: 'ASC',
};

export const CUSTOMER_VIEW_DETAIL_PAGE = 'customerDetailPage';

export const VIEWLOGTYPEOPTIONS = [
  { label: 'User Log', value: 'user-log' },
  { label: 'HCOS Log', value: 'hcos-log' },
];

export const USERLOGACTIONOPTIONS = [
  { label: 'All', value: 'all' },
  { label: 'Add', value: 'add' },
  { label: 'Remove', value: 'remove' },
  { label: 'Move', value: 'move' },
  { label: 'Comments', value: 'comments' },
  { label: 'Labels', value: 'labels' },
];

export const HCOSLOGACTIONOPTIONS = [
  { label: 'Added', value: 'add' },
  { label: 'Moved', value: 'move' },
  { label: 'Deactivated', value: 'deactivate' },
];

export const LOGTYPE = {
  userlog: 'User Log',
  hcoslog: 'HCOS Log',
};

export const USERLOG = 'User Log';

export const CHANGEACTIONTYPE = {
  hierarchy: 'hierarchy',
  label: 'label',
};

export const CHANGEVALUETYPE = {
  parent: 'parent',
  label: 'label',
};

export const FILTERSCREEN = {
  main: 'main',
  action: 'action',
};

export const CHECKBOXCLASS = 'form-check-input-color';

export const TABLE_NAME_SITE_PERFORMANCE = 'SitePerformance';

export const TABLE_NAME_ENGAGEMENT = 'Engagement';

export const TABLE_NAME_SITE_UTILIZATION = 'SiteUtilization';

export const TABLE_NAME_AFFILIATION = 'Affiliation';

export const TABLE_NAME_PRODUCT_MIX = 'ProductMix';

export const TABLE_NAME_PAYER_MIX = 'PayerMix';

export const TABLE_NAME_POLICY_DETAILS = 'PolicyDetails';

export const TABLE_NAME_SUGGESTED_ACTIONS = 'SuggestedActions';

export const TABLE_NAME_COPAY_ANALYTICS = 'CopayAnalytics';

export const TABLE_NAME_SITE_AFFILIATION = 'SiteAffiliation';

export const TABLE_NAME_STAKEHOLDER_ALERTS = 'StakeholderAlerts';

export const SITE_UTILIZATION_HIGH_MEDIUM_LOW_COLUMN_NAME = [
  'size',
  'breast_category',
  'lung_category',
  'leukemia_category',
  'lymphoma_category',
  'HHS_below_poverty_category',
  'no_insurance_category',
];

export const COMPARE_BENCHMARK_NO_DIMENSION_CHARTTYPE = 'KPI';
export const DIMENSION = 'dimension';
export const COMPARE_TIME_PERIOD = 'time-period';
export const COMPARE_BENCHMARK = 'compare-benchmark';
export const BENCHMARK_LEGEND_FIRST = 'Selected Filters';
export const BENCHMARK_LEGEND_SECOND = 'Nation';
export const COMPARE_KPI = 'multi-kpi';
export const OS_FLAG = 4;

export const COPAY_CONSTANT = {
  COPAY_TIMESLOT: `'Q' & Ceil(month(date(addmonths(Date(Date#(min({1}date_year_month), 'YYYYMM'), 'YYYYMMDD'),-12),'YYYYMM'))/3)&' '&
  year(date((Date(Date#(min({1}date_year_month), 'YYYYMM'), 'YYYYMMDD')),'YYYYMM'))  & ' - ' &
 'Q' & ceil(month(date(addmonths(Date(Date#(max({1}date_year_month), 'YYYYMM'), 'YYYYMMDD'),-12),'YYYYMM'))/3)&' '&
  year(date((Date(Date#(max({1}date_year_month), 'YYYYMM'), 'YYYYMMDD')),'YYYYMM'))`,
  VIEW_MEASURE: [
    'New Enrollment',
    'Total Enrollment',
    'Total Paid Claims',
    'Unique Utilizers',
  ],
};

export const CV_VIEW = {
  HEALTH_SYSTEM_VIEW: [1, 2, 3, 4],
  PAYER_SYSTEM_VIEW: [7, 8],
};
export const CV_VIEW_NAME = {
  HCO: 'HCO',
  MCO: 'MCO',
};
export const CONTRACT_SEGMENT = 'Contract Segment';

export const FILTERNAME = {
  Ecosystem: 'Ecosystem',
  TimePeriod: 'TimePeriod',
  Squad: 'Squad',
  Product: 'Product',
};

export const ACCOUNT_TYPE = {
  account: 'account',
  shared: 'shared',
  site: 'site',
  corp: 'corporate parent',
  os: 'owner subsidiary',
};

export const CUSTOMER_TYPE_ENTITY = {
  ACCOUNT: 'account',
  SITE: 'site',
  PARENTPAYER: 'parent payer',
  PAYER: 'payer',
};

export const CUSTOMER_TYPE = new Map([
  [1, 'account'],
  [4, 'account'],
  [2, 'site'],
  [3, 'site'],
  [7, 'parent payer'],
  [8, 'payer'],
]);

export const CUSTOMER_TYPE_FLAG = new Map([
  ['account', [1, 4]],
  ['site', [2, 3]],
  ['parent payer', [7]],
  ['payer', [8]],
]);

export const ADVANCE_FILTERS = {
  ADD_DIMENTION: 'dimension',
  ADD_KPI: 'multi-kpi',
  COMPARE_TIME_PERIOD: 'time-period',
  COMPARE_BENCHMARK: 'compare-benchmark',
};

export const PRODUCT_CONFIG = {
  MARKET_SHARE: 'MarketShare',
  GENERAL: 'General',
};
export const ADVANCE_FILTERS_OPTIONS = {
  dimension: {
    label: 'Add Dimension',
    value: DIMENSION,
    placeholder: 'Add Dimension',
    tileView: 'chart',
  },
  'multi-kpi': {
    label: 'Add KPI',
    value: COMPARE_KPI,
    placeholder: 'Select KPI',
    tileView: 'table',
  },
  'compare-benchmark': {
    label: 'Compare Benchmark',
    value: COMPARE_BENCHMARK,
    placeholder: 'Select Benchmark',
    tileView: 'chart',
  },
  'time-period': {
    label: 'Compare Time Period',
    value: COMPARE_TIME_PERIOD,
    placeholder: '',
    tileView: 'chart',
  },
};

export const DIMENSION_NAME = {
  PRODUCT: 'Product',
};

export const VIEW_CATEGORY = {
  CREATED: 'created',
  SHARED: 'shared',
};

export const HEIGHT_BREAKPOINTS = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
};
export const MYVIEW_TILE_LIMIT = 20;
export const INSIGHTBOARD_TILE_LIMIT = 12;

export const PAYMENT_METHOD = 'Payment-Method';
export const SUPERGROUP_GPO_INDICATOR = 'Oncology-Group';
export const PRIORITY_ADD_SUCCESS_MSG =
  ' has been successfully added as your priority customer, and you have been designated as a Point of Contact.';
export const PRIORITY_ADD_ERROR_MSG =
  'Unable to set priority! Only customers within your aligned ecosystems can be marked as a priority. Contact the C360 team for questions.';

export const PayerMixField = {
  ParentPayer: 'PayerMixParentPayer',
  Payer: 'PayerMixPayer',
  Product: 'PayerMixProduct',
  Indication: 'PayerMixIndication',
  BookOfBusiness: 'PayerMixBookOfBusiness',
  CompetitorProduct: 'PayerMixCompetitorProduct',
  BenefitType: 'PayerMixBenefitType',
  EcosystemName: 'PayerMixEcosystemName',
};

export const PolicyDetailsField = {
  Payer: 'PolicyDetailPayer',
  Plan: 'PolicyDetailPlan',
  Product: 'PolicyDetailProduct',
  Indication: 'PolicyDetailIndication',
  CompetitorProduct: 'PolicyDetailCompetitorProduct',
  EcosystemName: 'PolicyDetailEcosystemName',
  BookOfBusiness: 'PolicyDetailBookOfBusiness',
  BenefitType: 'PolicyDetailBenefitType',
  PolicyState: 'PolicyDetailState',
};

export const EcosystemOpportunityField = {
  Product: 'EcoOppProduct',
  Indication: 'EcoOppIndication',
  CompetitorBrand: 'EcoOppCompetitorProduct',
  BookOfBusiness: 'EcoOppBookOfBusiness',
  BenefitType: 'EcoOppBenefitType',
  Region: 'EcoOppRegion',
  Ecosystem: 'EcoOppEcosystemName',
};

export const POLICY_DETAILS_COLUMNS = [
  {
    id: 1,
    title: 'MDM Payer ID',
    dataIndex: 'mdmId',
    key: 'MdmId',
    isMandatory: 'Y',
    width: 180,
    sorter: true,
    fixed: 'left',
    columnVisiblity: ColumnVisiblity.Optional,
    render: (value, record) => {
      return <span>{record?.mcoEntity?.mdmId}</span>;
    },
  },

  {
    id: 2,
    title: 'Payer',
    dataIndex: 'mcoEntity',
    key: 'EntityName',
    isMandatory: 'Y',
    width: 180,
    sorter: true,
    fixed: 'left',
    columnVisiblity: ColumnVisiblity.Mandatory,
    render: (value) => {
      return <span>{value?.entityName}</span>;
    },
  },
  {
    id: 3,
    title: 'Book of Business',
    dataIndex: 'bookOfBusiness',
    key: 'BookOfBusiness',
    isMandatory: 'Y',
    width: 200,
    sorter: true,
    columnVisiblity: ColumnVisiblity.Mandatory,
  },
  {
    id: 4,
    title: 'Benefit Type',
    dataIndex: 'benefitType',
    key: 'BenefitType',
    isMandatory: 'Y',
    width: 160,
    sorter: true,
    columnVisiblity: ColumnVisiblity.Mandatory,
  },
  {
    id: 16,
    key: 'ecosystem',
    title: 'Ecosystem Metrics',
    isMandatory: 'Y',
    className: 'parent-header',
    children: [
      {
        id: 5,
        dataIndex: 'entitySales',
        key: 'EntitySales',
        label: 'Estimated Payer Sales ($)', // Will be used in Setting popupover
        title: renderTitleTooltip(
          'Estimated Payer Sales ($)',
          'Estimated Payer Sales (R12M) is a calculated metric leveraging Lives, Product Sales and Product Book of Business mix. This metric is affected by Product, Book of Business, Ecosystem, and Benefit Type. This metric is NOT affected by Indication.'
        ),
        isMandatory: 'Y',
        width: 170,
        render: (value) => {
          const formattedNumber =
            '$' +
            Number(value).toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
          return <span>{formattedNumber}</span>;
        },
        sorter: true,
        columnVisiblity: ColumnVisiblity.Default,
      },
      {
        id: 6,
        dataIndex: 'entityContributionToGeography',
        key: 'EntityContributionToGeography',
        label: 'Payer % of Geography', // Will be used in Setting popupover
        title: renderTitleTooltip(
          'Payer % of Geography',
          'This metric represents the contribution of Estimated Sales for this Payer, Book of Business, and Benefit Type in the selected geography to all Gross Sales in that geography for all books of business and all benefit types. The calculation method is product-specific. This metric is NOT affected by Indication. For Xolair, AHR, and Actemra SC, this metric does not consider benefit type and instead always shows Plantrak pharmacy sales.'
        ),
        isMandatory: 'Y',
        width: 150,
        render: (value) => {
          if (value === '-' || value === undefined) {
            return '-';
          } else {
            const formattedNumber = Number(value).toFixed(2) + '%';
            return <span>{formattedNumber}</span>;
          }
        },
        sorter: true,
        columnVisiblity: ColumnVisiblity.Default,
        defaultSortOrder: 'descend',
      },
    ],
  },
  {
    id: 17,
    key: 'policy',
    title: 'Policy Details',
    isMandatory: 'Y',
    className: 'parent-header',
    children: [
      {
        id: 7,
        dataIndex: 'policyStatus',
        key: 'PolicyStatus',
        label: 'Policy Status',
        title: 'Policy Status',
        isMandatory: 'Y',
        width: 160,
        sorter: true,
        columnVisiblity: ColumnVisiblity.Default,
      },
      {
        id: 8,
        dataIndex: 'compBrandPolicyStatus',
        key: 'CompBrandPolicyStatus',
        label: 'Competitor Brand Policy Status',
        title: 'Competitor Brand Policy Status',
        isMandatory: 'Y',
        width: 160,
        sorter: true,
        columnVisiblity: ColumnVisiblity.Default,
      },
      {
        id: 9,
        dataIndex: 'accessPosition',
        key: 'AccessPosition',
        label: 'Relative Access Position',
        title: renderTitleTooltip(
          'Relative Access Position',
          'Select Competitor Brand to populate access position'
        ),
        isMandatory: 'Y',
        width: 230,
        sorter: true,
        render: (text, record) => {
          const accessPossitions = Object.values(RelativeAccessPossition);
          if (!accessPossitions.includes(text)) return '-';
          return (
            <Tag
              color={
                text === RelativeAccessPossition.Advantaged
                  ? styleVars.color_green
                  : text === RelativeAccessPossition.Parity
                    ? styleVars.color_yellow_2
                    : text === RelativeAccessPossition?.Disadvantaged
                      ? styleVars.color_red_2
                      : ''
              }>
              {text}
            </Tag>
          );
        },
        columnVisiblity: ColumnVisiblity.Default,
      },
      {
        id: 10,
        dataIndex: 'statusConsistencyAcrossPlans',
        key: 'StatusConsistencyAcrossPlans',
        label: 'Status Consistency across Plan Lives',
        title: renderTitleTooltip(
          'Status Consistency across Plan Lives',
          'This metric shows the consistency (H/M/L) of this particular policy status across all lives for this Payer. For example, if 80% of lives for this Payer all have the same policy status, the displayed metric is "high".'
        ),
        isMandatory: 'Y',
        width: 240,
        sorter: true,
        columnVisiblity: ColumnVisiblity.Default,
      },
      {
        id: 11,
        dataIndex: 'paRequired',
        key: 'PARequired',
        label: 'PA Required',
        title: renderTitleTooltip(
          'PA Required',
          'Prior Authorization Required'
        ),
        isMandatory: 'Y',
        width: 170,
        sorter: true,
        columnVisiblity: ColumnVisiblity.Default,
      },
      {
        id: 12,
        dataIndex: 'stepEdits',
        key: 'StepEdits',
        label: 'Step Edit',
        title: renderTitleTooltip(
          'Step Edit',
          'Is the patient required to use a different brand before they can start using the selected GNE brand?'
        ),
        isMandatory: 'Y',
        width: 170,
        sorter: true,
        columnVisiblity: ColumnVisiblity.Default,
      },
      {
        id: 13,
        dataIndex: 'stepProducts',
        key: 'StepProducts',
        label: 'Step Brand',
        title: renderTitleTooltip(
          'Step Brand',
          'If Step Edits are in place, which brand(s) is the patient required to use prior to the selected GNE brand?'
        ),
        isMandatory: 'Y',
        width: 250,
        sorter: true,
        columnVisiblity: ColumnVisiblity.Default,
      },
      {
        id: 14,
        dataIndex: 'policyLink',
        key: 'PolicyLink',
        label: 'Policy Link',
        title: 'Policy Link',
        isMandatory: 'Y',
        width: 270,
        sorter: true,
        columnVisiblity: ColumnVisiblity.Default,
      },
      {
        id: 15,
        dataIndex: 'statusOverwrite',
        key: 'StatusOverwrite',
        label: 'Policy Status Overwritten',
        title: renderTitleTooltip(
          'Policy Status Overwritten',
          'This flag indicates if the policy data has been overwritten through Policy Intelligence.'
        ),
        isMandatory: 'Y',
        width: 150,
        sorter: true,
        columnVisiblity: ColumnVisiblity.Optional,
      },
      {
        id: 16,
        dataIndex: 'policyUpdateURL',
        key: 'PolicyUpdateURL',
        label: 'Policy Intelligence Update Form',
        title: renderTitleTooltip(
          'Policy Intelligence Update Form',
          'In case any policy related data may be incorrect, please use this link to submit a data change request.'
        ),
        isMandatory: 'Y',
        width: 270,
        sorter: true,
        columnVisiblity: ColumnVisiblity.Mandatory,
      },
    ],
  },
];
export const SUGGESTED_ACTIONS_COLUMNS = [
  {
    id: 1,
    title: renderTitleTooltip(
      'ACCELERATE: High-Priority Growth',
      'Ecosystems that fall in this category are ecosystems where the Payer has a large contribution to the ecosystem and vice versa. Generally, these ecosystems have a large opportunity for pull-through for the Payer based on favorable access position in the Ecosystem and importance of the Payer to the Ecosystem. Market share in the Ecosystem vs National levels indicates this Payer has potential opportunities, hence pull-through may be needed.'
    ),
    dataIndex: 'accelerate',
    key: 'accelerate',
    isMandatory: 'Y',
    width: 265,
  },
  {
    id: 2,
    title: renderTitleTooltip(
      'MAINTAIN: Incremental Growth',
      'Ecosystems in this category are not a priority given their sales volume and contribution to Payer. However, if the Payer’s market share falls below national average, it could be performing better. Based on the Payer’s favorable access position in the Ecosystem, there may be some opportunity for pull through.'
    ),
    dataIndex: 'maintain',
    key: 'maintain',
    isMandatory: 'Y',
    width: 245,
  },
  {
    id: 3,
    title: renderTitleTooltip(
      'LEARN: Replicate Success',
      'Ecosystems in this category can be referred to for pull- or push-through learnings or best practices. Generally, the Payer is performing well in these ecosystems despite the ecosystem’s market share compared to the nation. There may be learnings that can be obtained from this Payer that can be applied for other Payers in the Ecosystem, or for the same Payer in different Ecosystems'
    ),
    dataIndex: 'learn',
    key: 'learn',
    isMandatory: 'Y',
    width: 220,
  },
  {
    id: 4,
    title: renderTitleTooltip(
      'DEFEND: Secure Patient Access',
      'Ecosystems in this category may benefit from push-through assessment and support.'
    ),
    dataIndex: 'defend',
    key: 'defend',
    isMandatory: 'Y',
    width: 250,
  },
];

export const INSIGHT_TYPE = {
  SAMPLE: 'sample',
  GENERAL: 'general',
};

export const VIEW_TYPE = {
  SAMPLE: 'sample',
  GENERAL: 'general',
};

export const INSIGHT_TYPE_CODE = {
  SAMPLE: 3,
  GENERAL: 4,
};

export const PayerMixDataKeyFieldMapping = arrayToObject(
  PAYER_MIX_COLUMNS,
  'dataIndex',
  'key'
);

export const PolicyDetailFieldMapping = nestedArrayToObject(
  POLICY_DETAILS_COLUMNS,
  'dataIndex',
  'key'
);

export const BenchMarkKPIColumns = [
  'LivesNormNatPayerMarketShare',
  'NationalMarketShare',
  'EcoToNatPayerSalesBench',
  'PayerToEcoSalesBench',
];

export const ECOSYSTEM_OPPORTUNITY_COLUMNS_PAYER = [
  {
    id: 1,
    title: 'Ecosystem',
    label: 'Ecosystem',
    dataIndex: 'ecosystemName',
    key: 'EcoName',
    isMandatory: 'Y',
    width: 160,
    sorter: createSecureSorter('ecosystemName', 'string'),
    fixed: 'left',
    columnVisiblity: ColumnVisiblity.Mandatory,
  },
  {
    id: 2,
    title: renderTitleTooltip(
      'Suggested Action',
      'The ecosystems are categorized into priority statuses based on the opportunity for pull-through given Parent Payer contribution and access position in the ecosystem, and further ranked in terms of relative priority. National averages are used for benchmarking purposes to identify opportunity and learning segments.'
    ),
    label: 'Suggested Action',
    dataIndex: 'ecoOppSegment',
    key: 'EcoOppSegment',
    isMandatory: 'Y',
    width: 250,
    sorter: createSecureSorter('ecoOppSegment', 'string'),
    columnVisiblity: ColumnVisiblity.Default,
  },
  {
    id: 3,
    title: renderTitleTooltip(
      'Relative Access Position',
      'Shows the relative access position of the selected Payer within the Ecosystem for the selected product, indication, and competitor brand.'
    ),
    label: 'Relative Access Position',
    dataIndex: 'payerAccessPos',
    key: 'PayerAccessPos',
    isMandatory: 'Y',
    width: 160,
    sorter: createSecureSorter('payerAccessPos', 'string'),
    columnVisiblity: ColumnVisiblity.Default,
    render: (text) => {
      const accessPositions = Object.values(RelativeAccessPossition);
      if (!accessPositions.includes(text)) return '-';
      return (
        <Tag
          color={
            text === RelativeAccessPossition.Advantaged
              ? styleVars.color_green
              : text === RelativeAccessPossition.Parity
                ? styleVars.color_yellow_2
                : text === RelativeAccessPossition.Disadvantaged
                  ? styleVars.color_red_2
                  : ''
          }>
          {text}
        </Tag>
      );
    },
  },
  {
    id: 4,
    title: renderTitleTooltip(
      'Estimated Payer Sales',
      'Estimated Payer Sales for the selected Ecosystem'
    ),
    label: 'Estimated Payer Sales',
    dataIndex: 'salesNumber',
    key: 'EstPayerSales',
    isMandatory: 'Y',
    width: 148,
    sorter: createSecureSorter('salesNumber.estimatedPayer', 'number'),
    defaultSortOrder: 'descend',
    columnVisiblity: ColumnVisiblity.Default,
    render: (value, record) => {
      return (
        <span>
          {record.salesNumber?.estimatedPayer
            ? `$${Number(record.salesNumber?.estimatedPayer).toLocaleString(
                'en-US',
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }
              )}`
            : record.salesNumber?.estimatedPayer}
        </span>
      );
    },
  },
  {
    id: 5,
    title: renderTitleTooltip(
      'Payer-Specific Product Market Share',
      '[Lives-normalized] Ecosystem-level market share for the selected product relative to the market basket, and for the selected Payer (R3M)'
    ),
    label: 'Payer-Specific Product Market Share',
    dataIndex: 'marketSharePercent',
    key: 'LivesNormPayerMarketShare',
    isMandatory: 'Y',
    width: 160,
    sorter: createSecureSorter('marketSharePercent.livesNormPayer', 'number'),
    columnVisiblity: ColumnVisiblity.Default,
    render: (value, record) => {
      return (
        <span>
          {record.marketSharePercent?.livesNormPayer &&
          record.marketSharePercent?.livesNormPayer !== NOT_AVAILABLE
            ? `${Number(record.marketSharePercent?.livesNormPayer).toFixed(2)} %`
            : record.marketSharePercent?.livesNormPayer}
        </span>
      );
    },
  },
  {
    id: 6,
    title: renderTitleTooltip(
      'National Payer-Specific Product Market Share',
      '[Lives-normalized] National-level market share for the selected product relative to the market basket, and for the selected Payer (R3M)'
    ),
    label: 'National Payer-Specific Product Market Share',
    dataIndex: 'marketSharePercent',
    key: 'LivesNormNatPayerMarketShare',
    isMandatory: 'Y',
    width: 170,
    sorter: createSecureSorter(
      'marketSharePercent.livesNormNationPayer',
      'number'
    ),
    columnVisiblity: ColumnVisiblity.Optional,
    render: (value, record) => {
      return (
        <span>
          {record.marketSharePercent?.livesNormNationPayer &&
          record.marketSharePercent?.livesNormNationPayer !== NOT_AVAILABLE
            ? `${Number(record.marketSharePercent?.livesNormNationPayer).toFixed(2)}%`
            : record.marketSharePercent?.livesNormNationPayer}
        </span>
      );
    },
  },
  {
    id: 7,
    title: renderTitleTooltip(
      'Product Market Share (Payer-Agnostic)',
      'Represents the GNE Product’s market share within the Ecosystem for the full calendar quarter. If the current quarter’s data is incomplete, the previous quarter’s data will be used.'
    ),
    label: 'Product Market Share (Payer-Agnostic)',
    dataIndex: 'marketSharePercent',
    key: 'EcoMarketShare',
    isMandatory: 'Y',
    width: 160,
    sorter: createSecureSorter('marketSharePercent.ecosystem', 'number'),
    columnVisiblity: ColumnVisiblity.Default,
    render: (value, record) => {
      return (
        <span>
          {record.marketSharePercent?.ecosystem &&
          record.marketSharePercent?.ecosystem !== NOT_AVAILABLE
            ? `${Number(record.marketSharePercent?.ecosystem).toFixed(2)}%`
            : record.marketSharePercent?.ecosystem}
        </span>
      );
    },
  },
  {
    id: 8,
    title: renderTitleTooltip(
      'National Product Market Share (Payer-Agnostic)',
      'National-level market share for the selected product relative to the market basket, included as a benchmark (R3M)'
    ),
    label: 'National Product Market Share (Payer-Agnostic)',
    dataIndex: 'marketSharePercent',
    key: 'NationalMarketShare',
    isMandatory: 'Y',
    width: 180,
    sorter: createSecureSorter('marketSharePercent.national', 'number'),
    columnVisiblity: ColumnVisiblity.Optional,
    render: (value, record) => {
      return (
        <span>
          {record.marketSharePercent?.national &&
          record.marketSharePercent?.national !== NOT_AVAILABLE
            ? `${Number(record.marketSharePercent?.national).toFixed(2)}%`
            : record.marketSharePercent?.national}
        </span>
      );
    },
  },
  {
    id: 9,
    title: renderTitleTooltip(
      'Estimated Contribution to National Payer Sales (all BoB)',
      'Shows the percentage of the selected Ecosystem’s sales contribution to the selected Payer’s total national sales. This value helps gauge the relevance of the Ecosystem to the Payer’s overall business.'
    ),
    label: 'Estimated Contribution to National Payer Sales (all BoB)',
    dataIndex: 'salesPercent',
    key: 'EcoToNatPayerSales',
    isMandatory: 'Y',
    width: 210,
    sorter: createSecureSorter('salesPercent.ecoToNationPayer', 'number'),
    columnVisiblity: ColumnVisiblity.Default,
    render: (value, record) => {
      return (
        <span>
          {record.salesPercent?.ecoToNationPayer &&
          record.salesPercent?.ecoToNationPayer !== NOT_AVAILABLE
            ? `${Number(record.salesPercent?.ecoToNationPayer).toFixed(2)}%`
            : record.salesPercent?.ecoToNationPayer}
        </span>
      );
    },
  },
  {
    id: 10,
    title: renderTitleTooltip(
      'Average Estimated Contribution to National Payer Sales (all BoB) Across Payers',
      "Represents the benchmark for equal contribution across all Ecosystems to a Payer’s national sales. This line is constant and does not change with filter selections. If an Ecosystem's contribution to National Payer Sales falls below this benchmark, the Ecosystem may be considered a lower priority for pull-through for the Payer."
    ),
    label:
      'Average Estimated Contribution to National Payer Sales (all BoB) Across Payers',
    dataIndex: 'benchmark',
    key: 'EcoToNatPayerSalesBench',
    isMandatory: 'Y',
    width: 245,
    sorter: createSecureSorter('benchmark.ecoToNatPayerSales', 'number'),
    columnVisiblity: ColumnVisiblity.Optional,
    render: (value, record) => {
      return (
        <span>
          {record.benchmark?.ecoToNatPayerSales &&
          record.benchmark?.ecoToNatPayerSales !== NOT_AVAILABLE
            ? `${Number(record.benchmark?.ecoToNatPayerSales).toFixed(2)}%`
            : record.benchmark?.ecoToNatPayerSales}
        </span>
      );
    },
  },
  {
    id: 11,
    title: renderTitleTooltip(
      'Estimated Payer Contribution to Ecosystem (all BoB)',
      'Shows the percentage contribution of the selected Payer to total GNE Product sales within the Ecosystem. Higher values indicate greater influence of the (Parent) Payer to the Ecosystem.'
    ),
    label: 'Estimated Payer Contribution to Ecosystem (all BoB)',
    dataIndex: 'salesPercent',
    key: 'PayerToEcoSales',
    isMandatory: 'Y',
    width: 200,
    sorter: createSecureSorter('salesPercent.payerToEco', 'number'),
    columnVisiblity: ColumnVisiblity.Default,
    render: (value, record) => {
      return (
        <span>
          {record.salesPercent?.payerToEco &&
          record.salesPercent?.payerToEco !== NOT_AVAILABLE
            ? `${Number(record.salesPercent?.payerToEco).toFixed(2)}%`
            : record.salesPercent?.payerToEco}
        </span>
      );
    },
  },
  {
    id: 12,
    title: renderTitleTooltip(
      'Average Estimated Payer Contribution to Ecosystem (all BoB) Across Ecosystems',
      "Represents the benchmark for equal contribution across all Payers to Ecosystem sales. This line is dynamic and adjusts based on selected filters. If a (Parent) Payer's contribution to the Ecosystem's sales falls below this benchmark, the Payer may be considered a lower priority for pull-through for this Ecosystem."
    ),
    label:
      'Average Estimated Payer Contribution to Ecosystem (all BoB) Across Ecosystems',
    dataIndex: 'benchmark',
    key: 'PayerToEcoSalesBench',
    isMandatory: 'Y',
    width: 240,
    sorter: createSecureSorter('benchmark.payerToEcoSales', 'number'),
    columnVisiblity: ColumnVisiblity.Optional,
    render: (value, record) => {
      return (
        <span>
          {record.benchmark?.payerToEcoSales &&
          record.benchmark?.payerToEcoSales !== NOT_AVAILABLE
            ? `${Number(record.benchmark?.payerToEcoSales).toFixed(2)}%`
            : record.benchmark?.payerToEcoSales}
        </span>
      );
    },
  },
  {
    id: 13,
    title: renderTitleTooltip(
      'Market Basket Claims Volume (Payer-Agnostic) (R3M)',
      "Represents the total claims in the selected product's market basket for the Ecosystem, agnostic of Payer. Higher values typically indicate greater market size."
    ),
    label: 'Market Basket Claims Volume (Payer-Agnostic) (R3M)',
    dataIndex: 'salesNumber',
    key: 'EcoMarketBasketSales',
    isMandatory: 'Y',
    width: 185,
    sorter: createSecureSorter('salesNumber.ecoMarketBasket', 'number'),
    columnVisiblity: ColumnVisiblity.Default,
    render: (value, record) => {
      return (
        <span>
          {record?.salesNumber?.ecoMarketBasket &&
          record?.salesNumber?.ecoMarketBasket !== NOT_AVAILABLE
            ? Number(record?.salesNumber?.ecoMarketBasket).toFixed(2)
            : record?.salesNumber?.ecoMarketBasket}
        </span>
      );
    },
  },
];

export const ECOSYSTEM_OPPORTUNITY_COLUMNS_PARENT_PAYER = [
  {
    id: 1,
    title: 'Ecosystem',
    label: 'Ecosystem',
    dataIndex: 'ecosystemName',
    key: 'EcoName',
    isMandatory: 'Y',
    width: 160,
    sorter: createSecureSorter('ecosystemName', 'string'),
    fixed: 'left',
    columnVisiblity: ColumnVisiblity.Mandatory,
  },
  {
    id: 2,
    title: renderTitleTooltip(
      'Suggested Action',
      'The ecosystems are categorized into priority statuses based on the opportunity for pull-through given Parent Payer contribution and access position in the ecosystem, and further ranked in terms of relative priority. National averages are used for benchmarking purposes to identify opportunity and learning segments.'
    ),
    label: 'Suggested Action',
    dataIndex: 'ecoOppSegment',
    key: 'EcoOppSegment',
    isMandatory: 'Y',
    width: 250,
    sorter: createSecureSorter('ecoOppSegment', 'string'),
    columnVisiblity: ColumnVisiblity.Default,
  },
  {
    id: 3,
    title: renderTitleTooltip(
      'Relative Access Position',
      'Shows the relative access position of the selected Parent Payer within the Ecosystem for the selected product, indication, and competitor brand.'
    ),
    label: 'Relative Access Position',
    dataIndex: 'payerAccessPos',
    key: 'PayerAccessPos',
    isMandatory: 'Y',
    width: 160,
    sorter: createSecureSorter('payerAccessPos', 'string'),
    columnVisiblity: ColumnVisiblity.Default,
    render: (text) => {
      const accessPositions = Object.values(RelativeAccessPossition);
      if (!accessPositions.includes(text)) return '-';
      return (
        <Tag
          color={
            text === RelativeAccessPossition.Advantaged
              ? styleVars.color_green
              : text === RelativeAccessPossition.Parity
                ? styleVars.color_yellow_2
                : text === RelativeAccessPossition.Disadvantaged
                  ? styleVars.color_red_2
                  : ''
          }>
          {text}
        </Tag>
      );
    },
  },
  {
    id: 4,
    title: renderTitleTooltip(
      'Estimated Parent Payer Sales',
      'Estimated Parent Payer Sales for the selected Ecosystem'
    ),
    label: 'Estimated Parent Payer Sales',
    dataIndex: 'salesNumber',
    key: 'EstPayerSales',
    isMandatory: 'Y',
    width: 160,
    sorter: createSecureSorter('salesNumber.estimatedPayer', 'number'),
    defaultSortOrder: 'descend',
    columnVisiblity: ColumnVisiblity.Default,
    render: (value, record) => {
      return (
        <span>
          {record.salesNumber?.estimatedPayer
            ? `$${Number(record.salesNumber?.estimatedPayer).toLocaleString(
                'en-US',
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }
              )}`
            : record.salesNumber?.estimatedPayer}
        </span>
      );
    },
  },
  {
    id: 5,
    title: renderTitleTooltip(
      'Parent Payer-Specific Product Market Share',
      '[Lives-normalized] Ecosystem-level market share for the selected product relative to the market basket, and for the selected Parent Payer (R3M)'
    ),
    label: 'Parent Payer-Specific Product Market Share',
    dataIndex: 'marketSharePercent',
    key: 'LivesNormPayerMarketShare',
    isMandatory: 'Y',
    width: 170,
    sorter: createSecureSorter('marketSharePercent.livesNormPayer', 'number'),
    columnVisiblity: ColumnVisiblity.Default,
    render: (value, record) => {
      return (
        <span>
          {record.marketSharePercent?.livesNormPayer
            ? `${Number(record.marketSharePercent?.livesNormPayer).toFixed(2)} %`
            : record.marketSharePercent?.livesNormPayer}
        </span>
      );
    },
  },
  {
    id: 6,
    title: renderTitleTooltip(
      'National Parent Payer-Specific Product Market Share',
      '[Lives-normalized] National-level market share for the selected product relative to the market basket, and for the selected Parent Payer (R3M)'
    ),
    label: 'National Parent Payer-Specific Product Market Share',
    dataIndex: 'marketSharePercent',
    key: 'LivesNormNatPayerMarketShare',
    isMandatory: 'Y',
    width: 200,
    sorter: createSecureSorter(
      'marketSharePercent.livesNormNationPayer',
      'number'
    ),
    columnVisiblity: ColumnVisiblity.Optional,
    render: (value, record) => {
      return (
        <span>
          {record.marketSharePercent?.livesNormNationPayer
            ? `${Number(record.marketSharePercent?.livesNormNationPayer).toFixed(2)}%`
            : record.marketSharePercent?.livesNormNationPayer}
        </span>
      );
    },
  },
  {
    id: 7,
    title: renderTitleTooltip(
      'Product Market Share (Parent Payer-Agnostic)',
      'Represents the GNE Product’s market share within the Ecosystem for the full calendar quarter. If the current quarter’s data is incomplete, the previous quarter’s data will be used.'
    ),
    label: 'Product Market Share (Parent Payer-Agnostic)',
    dataIndex: 'marketSharePercent',
    key: 'EcoMarketShare',
    isMandatory: 'Y',
    width: 180,
    sorter: createSecureSorter('marketSharePercent.ecosystem', 'number'),
    columnVisiblity: ColumnVisiblity.Default,
    render: (value, record) => {
      return (
        <span>
          {record.marketSharePercent?.ecosystem
            ? `${Number(record.marketSharePercent?.ecosystem).toFixed(2)}%`
            : record.marketSharePercent?.ecosystem}
        </span>
      );
    },
  },
  {
    id: 8,
    title: renderTitleTooltip(
      'National Product Market Share (Parent Payer-Agnostic)',
      'National-level market share for the selected product relative to the market basket, included as a benchmark (R3M)'
    ),
    label: 'National Product Market Share (Parent Payer-Agnostic)',
    dataIndex: 'marketSharePercent',
    key: 'NationalMarketShare',
    isMandatory: 'Y',
    width: 185,
    sorter: createSecureSorter('marketSharePercent.national', 'number'),
    columnVisiblity: ColumnVisiblity.Optional,
    render: (value, record) => {
      return (
        <span>
          {record.marketSharePercent?.national
            ? `${Number(record.marketSharePercent?.national).toFixed(2)}%`
            : record.marketSharePercent?.national}
        </span>
      );
    },
  },
  {
    id: 9,
    title: renderTitleTooltip(
      'Estimated Contribution to National Parent Payer Sales (all BoB)',
      'Shows the percentage of the selected Ecosystem’s sales contribution to the selected Parent Payer’s total national sales. This value helps gauge the relevance of the Ecosystem to the Parent Payer’s overall business.'
    ),
    label: 'Estimated Contribution to National Parent Payer Sales (all BoB)',
    dataIndex: 'salesPercent',
    key: 'EcoToNatPayerSales',
    isMandatory: 'Y',
    width: 210,
    sorter: createSecureSorter('salesPercent.ecoToNationPayer', 'number'),
    columnVisiblity: ColumnVisiblity.Default,
    render: (value, record) => {
      return (
        <span>
          {record.salesPercent?.ecoToNationPayer
            ? `${Number(record.salesPercent?.ecoToNationPayer).toFixed(2)}%`
            : record.salesPercent?.ecoToNationPayer}
        </span>
      );
    },
  },
  {
    id: 10,
    title: renderTitleTooltip(
      'Average Estimated Contribution to National Parent Payer Sales (all BoB) Across Parent Payers',
      "Represents the benchmark for equal contribution across all Ecosystems to a Parent Payer’s national sales. This line is constant and does not change with filter selections. If an Ecosystem's contribution to National Parent Payer Sales falls below this benchmark, the Ecosystem may be considered a lower priority for pull-through for the Parent Payer."
    ),
    label:
      'Average Estimated Contribution to National Parent Payer Sales (all BoB) Across Parent Payers',
    dataIndex: 'benchmark',
    key: 'EcoToNatPayerSalesBench',
    isMandatory: 'Y',
    width: 265,
    sorter: createSecureSorter('benchmark.ecoToNatPayerSales', 'number'),
    columnVisiblity: ColumnVisiblity.Optional,
    render: (value, record) => {
      return (
        <span>
          {record.benchmark?.ecoToNatPayerSales
            ? `${Number(record.benchmark?.ecoToNatPayerSales).toFixed(2)}%`
            : record.benchmark?.ecoToNatPayerSales}
        </span>
      );
    },
  },
  {
    id: 11,
    title: renderTitleTooltip(
      'Estimated Parent Payer Contribution to Ecosystem (all BoB)',
      'Shows the percentage contribution of the selected Parent Payer to total GNE Product sales within the Ecosystem. Higher values indicate greater influence of the (Parent) Payer to the Ecosystem.'
    ),
    label: 'Estimated Parent Payer Contribution to Ecosystem (all BoB)',
    dataIndex: 'salesPercent',
    key: 'PayerToEcoSales',
    isMandatory: 'Y',
    width: 210,
    sorter: createSecureSorter('salesPercent.payerToEco', 'number'),
    columnVisiblity: ColumnVisiblity.Default,
    render: (value, record) => {
      return (
        <span>
          {record.salesPercent?.payerToEco
            ? `${Number(record.salesPercent?.payerToEco).toFixed(2)}%`
            : record.salesPercent?.payerToEco}
        </span>
      );
    },
  },
  {
    id: 12,
    title: renderTitleTooltip(
      'Average Estimated Parent Payer Contribution to Ecosystem (all BoB) Across Ecosystems',
      "Represents the benchmark for equal contribution across all Parent Payers to Ecosystem sales. This line is dynamic and adjusts based on selected filters. If a Parent Payer's contribution to the Ecosystem's sales falls below this benchmark, the Parent Payer may be considered a lower priority for pull-through for this Ecosystem."
    ),
    label:
      'Average Estimated Parent Payer Contribution to Ecosystem (all BoB) Across Ecosystems',
    dataIndex: 'benchmark',
    key: 'PayerToEcoSalesBench',
    isMandatory: 'Y',
    width: 265,
    sorter: createSecureSorter('benchmark.payerToEcoSales', 'number'),
    columnVisiblity: ColumnVisiblity.Optional,
    render: (value, record) => {
      return (
        <span>
          {record.benchmark?.payerToEcoSales
            ? `${Number(record.benchmark?.payerToEcoSales).toFixed(2)}%`
            : record.benchmark?.payerToEcoSales}
        </span>
      );
    },
  },
  {
    id: 13,
    title: renderTitleTooltip(
      'Market Basket Claims Volume (Parent Payer-Agnostic) (R3M)',
      "Represents the total claims in the selected product's market basket for the Ecosystem, agnostic of Payer. Higher values typically indicate greater market size."
    ),
    label: 'Market Basket Claims Volume (Parent Payer-Agnostic) (R3M)',
    dataIndex: 'salesNumber',
    key: 'EcoMarketBasketSales',
    isMandatory: 'Y',
    width: 185,
    sorter: createSecureSorter('salesNumber.ecoMarketBasket', 'number'),
    columnVisiblity: ColumnVisiblity.Default,
    render: (value, record) => {
      return (
        <span>
          {record?.salesNumber?.ecoMarketBasket
            ? Number(record?.salesNumber?.ecoMarketBasket).toFixed(2)
            : record?.salesNumber?.ecoMarketBasket}
        </span>
      );
    },
  },
];

export const EcosystemOpportunityFieldMapping = nestedArrayToObject(
  ECOSYSTEM_OPPORTUNITY_COLUMNS_PAYER,
  'dataIndex',
  'key'
);

export const VIEW_ACTION_TYPE = {
  DUPLICATE: 'duplicate',
  ADD_NEW_VIEW: 'addNewView',
  CHANGE_VIEW: 'changeView',
};

export const HELP_MODAL_LINK_FOR_UPDATE =
  'https://drive.google.com/file/d/16gkB4t54e4pIgDkeeL12icDcO9oUTy_k/';

export const ECOSYSTEM_OPPORTUNITY_HELP_LINK =
  'https://drive.google.com/drive/folders/1Kz9uIpTyEGUe8FyqBw_0QSzWJXQL6-4I';

export const HTTP_UNPROCESSABLE_ENTITY = 422;

// DD Configuration
export const DD_CONFIG = {
  DD_APP_ID: '48df8fec-6771-400d-a707-fb495462709a',
  DD_PUBLIC_CLIENT_ID: 'pub831daf53606ad1eccf5cfd51eba3d917',
  DD_SITE: 'us5.datadoghq.com',
  DD_SERVICE: 'c360',
  DD_VERSION: '1.0.0',
};

// This keys are mapped with DB Component Access Table values to check component access
// But few kesy are added which are not present in DB Component Access Table mostly used in front end to restrict api calls based on activeSectionTab

export const COMPONENT_MAPPING = {
  Insights: 'Insights',
  Engagements: 'Engagements',
  SitePerformance: 'Site-Performance',
  SiteUtilization: 'Site-Utilization',
  Affiliations: 'Affiliations',
  CopayAnalytics: 'CopayAnalytics',
  ProductMix: 'Product-Mix',
  PayerMix: 'Payer-Mix-Table',
  PolicyDetails: 'Policy-Detail-Table',
  PolicyDetailsParentPayer: 'Policy-Detail-Parent-Payer',
  PolicyDetailsPayer: 'Policy-Detail-Payer',
  EcosystemOpportunity: 'Ecosystem-Opportunity',
};

export const TRUE = 'True';

export const STAKEHOLDER_ALERTS_COLUMNS = [
  {
    id: 1,
    dataIndex: 'stakeholderName',
    key: 'stakeholderName',
    title: 'Stakeholder Name',
    isMandatory: 'Y',
    width: 150,
    fixed: 'left',
    sorter: true,
    align: 'left',
  },
  {
    id: 2,
    dataIndex: 'nps',
    key: 'nps',
    title: 'NPS',
    isMandatory: 'Y',
    width: 80,
    align: 'left',
    sorter: true,
    render: (value, record) => (
      <span>
        {value === 'NaN' ? '-' : value}
        {record.npsAlertFlag && (
          <i className='icon icon__warning ms-2 icon_box'></i>
        )}
      </span>
    ),
  },
  {
    id: 3,
    dataIndex: 'trustedPartner',
    key: 'trustedPartner',
    title: 'Trusted Partner',
    isMandatory: 'Y',
    width: 120,
    align: 'left',
    sorter: true,
    render: (value, record) => (
      <span>
        {value === 'NaN' ? '-' : value}
        {record.trustedPartnerAlertFlag && (
          <i className='icon icon__warning ms-2 icon_box'></i>
        )}
      </span>
    ),
  },
  {
    id: 4,
    dataIndex: 'likelihoodToPrescribe',
    key: 'likelihoodToPrescribe',
    title: 'Likelihood to Prescribe',
    isMandatory: 'Y',
    width: 160,
    align: 'left',
    sorter: true,
    render: (value, record) => (
      <span>
        {value === 'NaN' ? '-' : value}
        {record.likelihoodToPrescribeAlertFlag && (
          <i className='icon icon__warning ms-2 icon_box'></i>
        )}
      </span>
    ),
  },
  {
    id: 5,
    dataIndex: 'mostTrustedPartner',
    key: 'mostTrustedPartner',
    title: 'Most Trusted Partner',
    isMandatory: 'Y',
    width: 150,
    sorter: true,
    align: 'left',
    render: (value, record) => (
      <span>
        {value === 'NaN' ? '-' : value}
        {record.mostTrustedPartnerAlertFlag && (
          <i className='icon icon__warning ms-2 icon_box'></i>
        )}
      </span>
    ),
  },
  {
    id: 6,
    dataIndex: 'surveyResponseDate',
    key: 'surveyResponseDate',
    title: 'Survey Feedback Date',
    isMandatory: 'Y',
    width: 160,
    sorter: true,
    align: 'left',
    render: (value) => {
      if (!moment(value)?.isValid()) return '-';
      return <span> {moment(value)?.format(VIEW_FILTER_DATE_FORMAT)}</span>;
    },
  },
  {
    id: 7,
    dataIndex: 'surveyResponse',
    key: 'surveyResponse',
    title: 'Survey Feedback',
    isMandatory: 'Y',
    width: 180,
    sorter: true,
    align: 'left',
    render: (value) => {
      return value ? (
        <SelectableTooltip title={value}>
          <span>
            {value.length > 180 ? `${value.substring(0, 180)}...` : value}
          </span>
        </SelectableTooltip>
      ) : (
        '-'
      );
    },
  },
  {
    id: 8,
    dataIndex: 'SurveyId',
    key: 'SurveyId',
    title: 'Survey ID',
    isMandatory: 'Y',
    width: 150,
    sorter: true,
    render: (value) => <>{value}</>,
  },
];

export const MODAL_ACTION = {
  PROCEED: 'proceed',
  CANCEL: 'cancel',
  PROCEED_WITHOUT_SAVING: 'proceedWithoutSaving',
};

export const UNDEFINED = undefined;

export const SINGLE_SELECT_FILTER_KEYS = [
  'TimePeriod',
  'Payer_Mix_Product',
  'Payer_Indication',
  'Competitor_Brand',
  'Product',
  'CompetitorProduct',
  'Indication',
  'PolicyState',
  'EcoOppProduct',
  'EcoOppIndication',
  'EcoOppCompetitorProduct',
  'EcoOppBookOfBusiness',
  'EcoOppBenefitType',
];

export const BUTTON_STATE = {
  ENABLED: false,
  DISABLED: true,
};

export const PARENT_PAYER_VIEW_POLICY_STATUS_COLUMN_INFO =
  'The displayed value reflects policy status that is relevant for most lives under this Payer. Refer to "Status consistency across plan lives" to get a sense of how well this status reflects status for all lives under this  Payer. For Xolair, please select the specific formulation for the appropriate formulary data. For additional details on definitions of policy statuses, please refer to this';
export const PAYER_VIEW_POLICY_STATUS_COLUMN_INFO =
  'For Xolair, please select the specific formulation for the appropriate formulary data. For additional details on definitions of policy statuses, please refer to this';

export const POLICY_STATUS_COL_POPOVER_DESC =
  'The displayed value reflects policy status that is relevant for most lives under this Payer. For Xolair, please select the specific formulation for the appropriate formulary data. For additional details on definitions of policy statuses, please refer to this';

export const PARENT_PAYER_VIEW_RELATIVE_ACCESS_POSITION_COLUMN_INFO = (
  <>
    Shows how this product’s access compares to the selected competitor for the
    chosen indication.
    <br />
    Advantaged: Potentially fewer or less restrictive steps needed for access
    than competitor
    <br />
    Parity: Similar access to the competitor
    <br />
    Disadvantaged: Potentially more or stricter steps needed for access than the
    competitor
    <br />
    For additional details on relative access position, please refer to this
  </>
);

export const PAYER_VIEW_RELATIVE_ACCESS_POSITION_COLUMN_INFO = (
  <>
    Shows how this product’s access compares to the selected competitor for the
    chosen indication and policy state.
    <br />
    Advantaged: Potentially fewer or less restrictive steps needed for access
    than competitor
    <br />
    Parity: Similar access to the competitor
    <br />
    Disadvantaged: Potentially more or stricter steps needed for access than the
    competitor
    <br />
    For additional details on relative access position, please refer to this
  </>
);
export const RELATIVE_ACCESS_POSITION_COLUMN_NAME = 'Relative Access Position';

export const POLICY_STATUS_COL_POPOVER_LINK =
  'https://docs.google.com/presentation/d/1AAKedG4K6vcLniCxfqfAliNMMB6YG1mnnORDYva0F_E/edit?slide=id.p1#slide=id.p1';

export const RELATIVE_ACCESS_POSITION_COLUMN_POPOVER_LINK =
  'https://docs.google.com/presentation/d/12O7D1fkZ4zWcTlF-ezd2KUzsyLwx-dOgSvT5GrQ4fMY/edit?slide=id.g371ff3c4acb_1_278#slide=id.g371ff3c4acb_1_278';

export const BOB_BENEFIT_TYPE = {
  PHARMACY: 'Pharmacy',
  MEDICAL: 'Medical',
};
export const BOOK_OF_BUSINESS = 'BookOfBusiness';
export const NO_DATA_AVAILABLE = 'No Data Available';
export const PAYERMIX_PAYER_NAME_COLUMN = 'PayerName';
export const PAYERMIX_PAYER_MDMID_COLUMN = 'PayerMdmId';
export const PAYER_MDM_ID_COLUMN_NAME = 'MDM Plan ID';
export const POLICY_DETAILS_PLAN_COLUMN_NAME = 'Plan';

export const MODULE_NAME = {
  SitePerformance: 'Site_Performance',
  CopayAnalytics: 'Copay_Analytics',
  SiteUtilization: 'Site_Utilization',
  ProductMix: 'Product_Mix',
  BannerCRM: 'CRM',
  ContractSegment: 'Contract_Segment',
};
export const DEFAULT_TIME_PERIOD = {
  CopayAnalytics: 'R6M',
  SiteUtilization: 'R12M',
  BannerCRM: 'R12M',
  ContractSegment: 'QTR',
};

export const QUERY_KEY = {
  // Table Query Keys
  AffiliationsTable: 'AffiliationsTable',
  SiteAffiliationsTable: 'SiteAffiliationsTable',
  SitePerformanceTable: 'SitePerformanceTable',
  PayerMixTable: 'PayerMixTable',
  PolicyDetailsTable: 'PolicyDetailsTable',
  SiteUtilizationTable: 'SiteUtilizationTable',
  CopayAnalyticsTable: 'CopayAnalyticsTable',
  ProductMixTable: 'ProductMixTable',
  EcosystemOpportunityTable: 'EcosystemOpportunityTable',
  EngagementTable: 'EngagementTable',
  EngagementTimelinePill: 'EngagementTimelinePill',

  // Time Period Query Keys
  HCOTimePeriod: 'HCOTimePeriod',
  MCOTimePeriod: 'MCOTimePeriod', // used in Banner, Policy Details and Ecosystem Opportunity.
  PayerMixTimePeriod: 'PayerMixTimePeriod',

  // Banner API Query Keys
  BOBMixData: 'BOBMixData',
  PayerPieMCOData: 'PayerPieMCOData',
  PayerPieHCOData: 'PayerPieHCOData',
  CustomerDetailData: 'CustomerDetailData', // used for address and affiliatedTo
  PathwayUsesData: 'PathwayUsesData',
  CrmKpiData: 'CrmKpiData',
  BeamChartData: 'BeamChartData', // used for account and site both
  OncGpoSuperGroupsData: 'OncGpoSuperGroupsData',
  StakeholderAlertsData: 'StakeholderAlertsData',

  TrendsAnalytics: 'TrendsAnalytics',
  DarwinReportsData: 'DarwinReportsData',
};

export const ACCESS_VIEWS = {
  PAYER: 'payeraccess',
  CONTRACT: 'contractaccess',
  ALL: 'allaccess',
  NONE: 'noaccess',
};

export const CHART_VIEWS = {
  CONTRACT: 'contract',
  PAYER: 'payer',
};

export const BANNER_LEGENDS = {
  NON_CONTRACTED: 'NON-CONTRACTED*',
  B_340: '340B',
};

export const HELP_USER_GUIDE_LINK =
  'https://docs.google.com/presentation/d/1RFUT_Lq6HVAo2epslyQGaPnTFtxgnGau7ITDIA-E5TY/edit#slide=id.g25c7b48c481_1_1530';
export const HELP_FAQs_LINK =
  'https://docs.google.com/document/d/1wbCK2avRIyyYRj9bqkU92HP9eGDVAJ3lVaI0h-XTLoE/edit?usp=sharing';
export const HELP_RAISE_REQUEST_LINK =
  'https://roche.service-now.com/teamzones?id=sc_cat_item&sys_id=9ed2999087b72114e5e440c30cbb3546&sysparm_category=7536ffc0876f69144f9432a90cbb35f0&tz_id=e0267b80876f69144f9432a90cbb35b4';
export const HELP_HOW_TO_VIDEOS_LINK =
  'https://drive.google.com/drive/folders/12Xn-m8aZpTnnYYy4NLMzm_QvEN1NNbu-';

export const OVERLAY_TRIGGER = ['click', 'hover'];
